export const ARTIST_PROFILES = {
  'monk-washington': {
    id: 'monk-washington',
    profileNumber: '001',
    name: 'Monk Americana',
    role: 'Musician / Multi-Instrumentalist / Entity',
    city: 'nyc',
    status: 'Field Transmission Active — NYC Signal',
    transmission: "Banjo, Blues & Signal Sovereignty — Monk Americana (Early-'90s 42nd Street Shuttle, 140th St Banjo Origin, The Bandroidz, The 1865 & Pianos NYC)",
    transmissionChronicleAudioUrl: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/audio/transmission_artist-monk-washington.mp3',
    fallbackAudioUrl: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/audio/transmission_artist-monk-washington.mp3',
    carriers: {
      en: {
        audioUrl: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/audio/transmission_artist-monk-washington.mp3',
        audioReady: true,
      },
      'fr-CA': {
        audioUrl: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/audio/transmission_artist-monk-washington_fr-ca.mp3',
        audioReady: true,
      },
    },
    transmissionType: 'Field Transmission Active',
    landingPath: '/nyc',
    landingLabel: 'NYC Page',
    radarPath: '/passport/radar?city=nyc',
    associatedVenueIds: ['pianos-nyc', 'victoria-nyc'],
    tags: ['Multi-Instrumentalist', 'Banjo', 'Blues', 'Signal Sovereignty', 'The Bandroidz', 'Band Droidz', 'The 1865', 'Pianos NYC', 'I Have A Dream Pop Festival', 'NYC Lineage', 'Post-Punk'],
    image: 'https://firebasestorage.googleapis.com/v0/b/togeevision-f3725.appspot.com/o/archives%2Fmonk-washington%2F1788985813658-IMG-20230708-WA0003.jpg?alt=media&token=45bb4293-6251-4690-bcda-af36e7db568d',
    imageAlt: 'Monk Americana — NYC Field Portrait, Banjo & Acoustic Roots Signal',
    imageCaption: "Monk Americana — NYC Field Portrait, Banjo & Acoustic Roots Signal, documenting his two-string walk home from 140th Street with his brother's banjo, his early-'90s 42nd Street Shuttle encounter with Honeychild Coleman, The Bandroidz, The 1865, and NYC stages.",
    relatedTransmissions: [
      {
        id: 'artist-honeychild-coleman',
        eyebrow: 'October 24, 2026 · Pianos NYC Upstairs Lounge (158 Ludlow St)',
        title: "Pianos NYC: 'I Have A Dream Pop Festival' — HoneyChild's DEM w/ Monk Americana & Jennie Oliver-Cretara",
        description: "Listen to the Saturday night Pianos NYC field transmission featuring Honeychild Coleman (HoneyChild's DEM), Monk Americana on guitar and tabletop electronics, and special guest Jennie Oliver-Cretara on viola for the 7-song continuous set culminating in 'The Salt.'",
        path: '/passport/transmissions/artist-honeychild-coleman',
        ctaLabel: 'Open Pianos Show w/ Honeychild Transmission →',
      },
      {
        id: 'venue-pianos-nyc',
        eyebrow: 'October 23–24, 2026 · 158 Ludlow Street, Lower East Side',
        title: "Pianos NYC: 'I Have A Dream Pop Festival' Room Chronicle (The Veldt, Diary, Day & Dream & Darksoft)",
        description: "Explore the Lower East Side festival room chronicle founded by Daniel and Danny Chavis of The Veldt.",
        path: '/passport/transmissions/venue-pianos-nyc',
        ctaLabel: 'Open Pianos Venue Chronicle →',
      },
    ],
    archiveItems: [
      {
        id: 'monk-pianos-honeychild-dem-audio-2026-10-24',
        title: "Pianos NYC Field Transmission — HoneyChild's DEM w/ Monk Americana & Jennie Oliver-Cretara ('The Salt')",
        date: 'October 24, 2026 · Pianos NYC',
        duration: 'Field Chronicle',
        visibility: 'public',
        type: 'audio',
        url: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/audio/transmission_artist-honeychild-coleman.mp3',
        accessUrl: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/audio/transmission_artist-honeychild-coleman.mp3',
        transmissionPath: '/passport/transmissions/artist-honeychild-coleman',
        transmissionLabel: 'Open Pianos Show w/ Honeychild Transmission →',
        caption: "Full Pianos Upstairs Lounge broadcast chronicle capturing Honeychild Coleman (HoneyChild's DEM), Monk Americana, and violist Jennie Oliver-Cretara across the 7-song October 24 set.",
      },
      {
        id: 'monk-pianos-honeychild-dem-video-clip-1-2026-10-24',
        title: "HoneyChild's DEM w/ Monk Americana & Biz — Live at Pianos NYC Upstairs Lounge (Saturday Night Clip I)",
        date: 'October 24, 2026 · Pianos NYC',
        duration: 'Live Stage Video',
        visibility: 'public',
        type: 'video',
        url: 'https://docs.google.com/videos/d/1qHQEHzuGGaaraJjhmIyjaZRXo0hxPN8xpSgkl3_zEOI/play?usp=sharing',
        accessUrl: 'https://docs.google.com/videos/d/1qHQEHzuGGaaraJjhmIyjaZRXo0hxPN8xpSgkl3_zEOI/play?usp=sharing',
        thumbnail: '/images/transmissions/nyc/pianos-honeychild-dem-monk-stage-red.jpg',
        transmissionPath: '/passport/transmissions/artist-honeychild-coleman',
        transmissionLabel: 'Open Pianos Show w/ Honeychild Transmission →',
        caption: "Saturday night stage video capture (IMG_3207) of Honeychild Coleman (HoneyChild's DEM), Monk Americana, and drummer Jason 'Biz' Lucas (The 1865) performing at Pianos NYC Upstairs Lounge (158 Ludlow Street) during the 'I Have A Dream Pop Festival.'",
      },
      {
        id: 'monk-pianos-honeychild-dem-video-clip-2-2026-10-24',
        title: "HoneyChild's DEM w/ Monk Americana, Biz & Jennie Oliver-Cretara — 'The Salt' Live at Pianos NYC (Saturday Night Clip II)",
        date: 'October 24, 2026 · Pianos NYC',
        duration: '4K Live Stage Video',
        visibility: 'public',
        type: 'video',
        url: 'https://docs.google.com/videos/d/1DxnuNZmyvx6XaJJEPIGwuq_Q4UY5-RKzt6WBxmgMyvA/play?usp=sharing',
        accessUrl: 'https://docs.google.com/videos/d/1DxnuNZmyvx6XaJJEPIGwuq_Q4UY5-RKzt6WBxmgMyvA/play?usp=sharing',
        thumbnail: '/images/transmissions/nyc/pianos-honeychild-dem-the-salt-viola.jpg',
        transmissionPath: '/passport/transmissions/artist-honeychild-coleman',
        transmissionLabel: 'Open Pianos Show w/ Honeychild Transmission →',
        caption: "Saturday night 4K stage video capture (PXL_20261025_003408137) of HoneyChild's DEM with Monk Americana, Biz on drums, and special guest Jennie Oliver-Cretara on viola performing 'The Salt' at Pianos NYC Upstairs Lounge.",
      },
      {
        id: 'monk-pianos-honeychild-dem-video-clip-3-2026-10-24',
        title: "HoneyChild's DEM w/ Monk Americana & Biz — Live at Pianos NYC Upstairs Lounge (Saturday Night Clip III)",
        date: 'October 24, 2026 · Pianos NYC',
        duration: 'Live Stage Video',
        visibility: 'public',
        type: 'video',
        url: 'https://docs.google.com/videos/d/1CYlQdBHyrkXJM_UVtJpzTLSPyVUCbCotMknqgZW8aFQ/play?usp=sharing',
        accessUrl: 'https://docs.google.com/videos/d/1CYlQdBHyrkXJM_UVtJpzTLSPyVUCbCotMknqgZW8aFQ/play?usp=sharing',
        thumbnail: '/images/transmissions/nyc/pianos-honeychild-dem-monk-disco-ball.jpg',
        transmissionPath: '/passport/transmissions/artist-honeychild-coleman',
        transmissionLabel: 'Open Pianos Show w/ Honeychild Transmission →',
        caption: "Saturday night stage video capture (IMG_3208) of Honeychild Coleman (HoneyChild's DEM), Monk Americana, and Biz under crimson neon and mirror-ball light at Pianos NYC (158 Ludlow Street).",
      },
      {
        id: 'monk-pianos-honeychild-dem-video-clip-4-2026-10-24',
        title: "HoneyChild's DEM w/ Monk Americana & Biz — Live at Pianos NYC Upstairs Lounge (Saturday Night Clip IV)",
        date: 'October 24, 2026 · Pianos NYC',
        duration: 'Live Stage Video',
        visibility: 'public',
        type: 'video',
        url: 'https://docs.google.com/videos/d/13VF0mI1ljMCaahOQ9XnE4KgscByzYxdPAi0pFqwI9Ok/play?usp=sharing',
        accessUrl: 'https://docs.google.com/videos/d/13VF0mI1ljMCaahOQ9XnE4KgscByzYxdPAi0pFqwI9Ok/play?usp=sharing',
        thumbnail: '/images/transmissions/nyc/pianos-honeychild-dem-quartet-wide.jpg',
        transmissionPath: '/passport/transmissions/artist-honeychild-coleman',
        transmissionLabel: 'Open Pianos Show w/ Honeychild Transmission →',
        caption: "Saturday night stage video capture (IMG_3209) of HoneyChild's DEM, Monk Americana, and Biz locked into a continuous dub-shoegaze groove at Pianos NYC Upstairs Lounge.",
      },
      {
        id: 'monk-pianos-honeychild-dem-live-stage-2026-10-24',
        title: "Pianos NYC Upstairs Lounge — HoneyChild's DEM w/ Monk Americana, Biz & Jennie Oliver-Cretara (Viola)",
        date: 'October 24, 2026 · Pianos NYC',
        duration: 'Live Stage Capture',
        visibility: 'public',
        type: 'image',
        url: '/images/transmissions/nyc/pianos-honeychild-dem-monk-stage-red.jpg',
        accessUrl: '/images/transmissions/nyc/pianos-honeychild-dem-monk-stage-red.jpg',
        transmissionPath: '/passport/transmissions/artist-honeychild-coleman',
        transmissionLabel: 'Open Pianos Show w/ Honeychild Transmission →',
        caption: "Live stage capture at Pianos NYC Upstairs Lounge (158 Ludlow Street) during the Saturday night 'I Have A Dream Pop Festival' showcase (left to right): Monk Americana on guitar and tabletop sampler in front of his Vox amplifier, Honeychild Coleman (HoneyChild's DEM) at center mic, and Biz on the Sonor drum kit.",
      },
      {
        id: 'monk-pianos-honeychild-dem-green-room-2026-10-24',
        title: 'Pianos NYC Green Room — Monk Americana, Honeychild Coleman, Jennie Olivera-Cretara & Biz (10/24/26)',
        date: 'October 24, 2026 · Pianos NYC',
        duration: 'Green Room Portrait',
        visibility: 'public',
        type: 'image',
        url: '/images/transmissions/nyc/pianos-honeychild-dem-monk-green-room.jpg',
        accessUrl: '/images/transmissions/nyc/pianos-honeychild-dem-monk-green-room.jpg',
        transmissionPath: '/passport/transmissions/artist-honeychild-coleman',
        transmissionLabel: 'Open Pianos Show w/ Honeychild Transmission →',
        caption: "Backstage inside the Pianos NYC Green Room (158 Ludlow Street, Lower East Side) on Saturday, October 24, 2026 during the 'I Have A Dream Pop Festival' (left to right): Monk Americana, Honeychild Coleman, Jennie Olivera-Cretara, and drummer Jason “Biz” Lucas (The 1865).",
      },
      {
        id: 'monk-pianos-honeychild-dem-setlist-2026-10-24',
        title: "HONEYCHILD COLEMAN's DEM — Pianos NYC Setlist (10/24/26)",
        date: 'October 24, 2026 · Pianos NYC',
        duration: '7-Song Stage Sheet',
        visibility: 'public',
        type: 'image',
        url: '/images/transmissions/nyc/pianos-honeychild-dem-setlist-2026-10-24.jpg',
        accessUrl: '/images/transmissions/nyc/pianos-honeychild-dem-setlist-2026-10-24.jpg',
        transmissionPath: '/passport/transmissions/artist-honeychild-coleman',
        transmissionLabel: 'Open Pianos Show w/ Honeychild Transmission →',
        caption: "Physical stage setlist taped to the Pianos floorboards: 'Echelon' (Loop 'It's Understood'), 'Drug Bags & Leaves' (Starts with Biz), 'December', 'Takeover', 'Heelspur Whisper', 'Circumstances', and 'The Salt' (featuring special guest Jennie Oliver-Cretara on viola).",
      },
      {
        id: 'monk-pianos-dream-pop-festival-2026-10-24',
        title: "Pianos NYC (158 Ludlow St) — 'I Have A Dream Pop Festival' w/ Honeychild Coleman (HoneyChild's DEM)",
        date: 'October 24, 2026 · Pianos NYC',
        duration: 'Festival Node',
        visibility: 'public',
        type: 'image',
        url: '/images/transmissions/nyc/pianos-ludlow-marquee-dream-pop.jpg',
        accessUrl: '/images/transmissions/nyc/pianos-ludlow-marquee-dream-pop.jpg',
        transmissionPath: '/passport/transmissions/artist-honeychild-coleman',
        transmissionLabel: 'Open Pianos Show w/ Honeychild Transmission →',
        caption: "Pianos marquee at 158 Ludlow Street on the Lower East Side for the 'I Have A Dream Pop Festival,' where Monk Americana accompanies Honeychild Coleman (HoneyChild's DEM).",
      },
      {
        id: 'monk-pianos-dream-pop-poster-2026-10-24',
        title: "I Have A Dream Pop Festival (Sat. 10/24/26) Official Lineup Poster — Pianos NYC",
        date: 'October 24, 2026 · Pianos NYC',
        duration: 'Festival Poster',
        visibility: 'public',
        type: 'image',
        url: '/images/transmissions/nyc/pianos-i-have-a-dream-pop-festival-poster-2026-10-24.png',
        accessUrl: '/images/transmissions/nyc/pianos-i-have-a-dream-pop-festival-poster-2026-10-24.png',
        transmissionPath: '/passport/transmissions/artist-honeychild-coleman',
        transmissionLabel: 'Open Pianos Show w/ Honeychild Transmission →',
        caption: "Official Saturday 10/24/26 'I Have A Dream Pop Festival' poster at Pianos (158 Ludlow St, Lower East Side) featuring The Veldt, Burnt Sugar (NYC), Honeychild Coleman's DEM (NYC), Spirit Hotel, Mahogany, Faith, and more.",
      },
      {
        id: 'monk-bandroidz-national-underground-2009-09-25',
        title: "The Bandroidz (Band Droidz) — 'Don't Believe / Favorite Sun' Live at National Underground NYC",
        date: 'September 25, 2009 · National Underground NYC',
        duration: '07:31 Live Video',
        visibility: 'public',
        type: 'video',
        url: 'https://vimeo.com/6791465?fl=tl&fe=ec',
        accessUrl: 'https://vimeo.com/6791465?fl=tl&fe=ec',
        thumbnail: '/images/transmissions/nyc/bandroidz-national-underground-2009.jpg',
        image: '/images/transmissions/nyc/bandroidz-national-underground-2009.jpg',
        caption: "Archival live performance (Sept. 25, 2009) of Monk Americana fronting The Bandroidz (Band Droidz) on electric guitar and vocals performing 'Don't Believe / Favorite Sun' at National Underground (159 East Houston Street, Lower East Side, NYC). Captured by Delano Franklin.",
        notes: "Archival live performance (Sept. 25, 2009) of Monk Americana fronting The Bandroidz (Band Droidz) on electric guitar and vocals performing 'Don't Believe / Favorite Sun' at National Underground (159 East Houston Street, Lower East Side, NYC). Captured by Delano Franklin.",
      },
      {
        id: 'monk-bandroidz-mountain-man-shrine-2011-03',
        title: "The Bandroidz (Band Droidz) — 'Mountain Man' Live at Shrine Harlem",
        date: 'March 2011 · Shrine World Music Venue (Harlem)',
        duration: '03:35 Live Video',
        visibility: 'public',
        type: 'video',
        url: 'https://vimeo.com/21657567?fl=tl&fe=ec',
        accessUrl: 'https://vimeo.com/21657567?fl=tl&fe=ec',
        thumbnail: '/images/transmissions/nyc/bandroidz-shrine-harlem-2011.jpg',
        image: '/images/transmissions/nyc/bandroidz-shrine-harlem-2011.jpg',
        caption: "Archival Uptown live performance (March 2011) of Monk Americana with The Bandroidz (Band Droidz) performing 'Mountain Man' at Shrine World Music Venue (2271 Adam Clayton Powell Jr. Blvd, Harlem, NYC). Captured by Delano Franklin.",
        notes: "Archival Uptown live performance (March 2011) of Monk Americana with The Bandroidz (Band Droidz) performing 'Mountain Man' at Shrine World Music Venue (2271 Adam Clayton Powell Jr. Blvd, Harlem, NYC). Captured by Delano Franklin.",
      },
      {
        id: 'monk-bandroidz-claremont-park-interview-2011-04',
        title: "Monk Americana (The Bandroidz) — 'The Spices of My Music' (Claremont Park, The Bronx)",
        date: 'April 2011 · Claremont Park, The Bronx',
        duration: '01:19 Field Interview',
        visibility: 'public',
        type: 'video',
        url: 'https://vimeo.com/21858173?fl=tl&fe=ec',
        accessUrl: 'https://vimeo.com/21858173?fl=tl&fe=ec',
        thumbnail: '/images/transmissions/nyc/bandroidz-monk-claremont-park-bronx-2011.jpg',
        image: '/images/transmissions/nyc/bandroidz-monk-claremont-park-bronx-2011.jpg',
        caption: "Cropped archival interview segment in Claremont Park, The Bronx (April 2011, filmed by Delano Franklin) opening directly with Monk Americana reflecting on how growing up in New York City—moving through the East Village across the '80s, the Upper West Side, his grandmother's home in Harlem, 88th Street off Columbus, and his sister's neighborhood in the Bronx in the early '70s—became 'the spices of my music.'",
        notes: "Cropped archival interview segment in Claremont Park, The Bronx (April 2011, filmed by Delano Franklin) opening directly with Monk Americana reflecting on how growing up in New York City—moving through the East Village across the '80s, the Upper West Side, his grandmother's home in Harlem, 88th Street off Columbus, and his sister's neighborhood in the Bronx in the early '70s—became 'the spices of my music.'",
      },
      {
        id: 'asset_1788985815024',
        title: 'Monk Americana — NYC Field Archive Still',
        date: 'September 9, 2026',
        duration: 'Image',
        visibility: 'public',
        type: 'image',
        url: 'https://firebasestorage.googleapis.com/v0/b/togeevision-f3725.appspot.com/o/archives%2Fmonk-washington%2F1788985813658-IMG-20230708-WA0003.jpg?alt=media&token=45bb4293-6251-4690-bcda-af36e7db568d',
        accessUrl: 'https://firebasestorage.googleapis.com/v0/b/togeevision-f3725.appspot.com/o/archives%2Fmonk-washington%2F1788985813658-IMG-20230708-WA0003.jpg?alt=media&token=45bb4293-6251-4690-bcda-af36e7db568d',
        caption: 'Monk Americana field archive still',
      },
      {
        id: 'asset_1788985013781',
        title: 'Monk Americana — Live Performance & Rehearsal Fragment',
        date: 'September 9, 2026',
        duration: 'Video',
        visibility: 'public',
        type: 'video',
        url: 'https://stream.mux.com/ZynH1dnM7e6qJkkvc01P6YXn4CQwG700D4G2xHMgplI3o.m3u8',
        muxPlaybackId: 'ZynH1dnM7e6qJkkvc01P6YXn4CQwG700D4G2xHMgplI3o',
        accessUrl: 'https://stream.mux.com/ZynH1dnM7e6qJkkvc01P6YXn4CQwG700D4G2xHMgplI3o.m3u8',
        muxStatus: 'ready',
        caption: 'Live performance and rehearsal fragment',
      },
      {
        id: 'monk-field-transmission-001',
        title: 'TogeeVision Field Transmission No. 1 — Banjo, Blues & Signal Sovereignty (Monk Americana)',
        date: 'October 2026 · NYC Field Archive',
        duration: '05:54 Field Chronicle',
        visibility: 'public',
        type: 'audio',
        url: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/audio/transmission_artist-monk-washington.mp3',
        accessUrl: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/audio/transmission_artist-monk-washington.mp3',
        caption: "Station broadcast chronicle ('Banjo, Blues & Signal Sovereignty - Monk Americana') documenting Monk's 140th Street two-string walk home with his brother's banjo, his early-'90s 42nd Street Shuttle origin encounter with Honeychild Coleman, sore fingers and banjo nights, Signal Sovereignty ('not a content creator'), The Bandroidz (2009–2011), The 1865, and Pianos NYC.",
      },
    ],
    origin: {
      title: 'The Origin Signal',
      subtitle: "140th Street Banjo Walk & 42nd Street Shuttle, Early '90s",
      body:
        "Monk Americana's signal begins with a banjo passed from his brother, a two-string walk home from 140th Street, and the realization that the instrument had changed the direction of his life before he had language for it. In the early '90s on the 42nd Street Shuttle line, he experienced a brain-splitting moment of recognition when he encountered Honeychild Coleman: a brown-skin punk rock Cure doll playing a black acoustic guitar in combat boots and a tutu.",
      note:
        'From 140th Street banjo roots to the 42nd Street Shuttle: recognizing a sovereign signal years before it becomes a broadcast.',
    },
    summary:
      "Monk Americana anchors TogeeVision Field Transmission No. 1 ('Banjo, Blues & Signal Sovereignty'): a blues-rooted, banjo-driven, NYC post-punk artist signal built around a two-string walk home from 140th Street with his brother's banjo, sore fingers after an hour-and-a-half set, banjo nights, live presence, archive protection, and a refusal to be flattened into a content creator. From his early-'90s 42nd Street Shuttle encounter with Honeychild Coleman, songwriting chemistry on 'Friends,' and fronting The Bandroidz (Band Droidz) at National Underground on Houston Street (2009) and Shrine in Harlem (2011) to contributing to The 1865 alongside Honeychild and Biz and accompanying HoneyChild's DEM at Pianos NYC (158 Ludlow Street) for the 'I Have A Dream Pop Festival,' his work bridges Lower East Side and Uptown stages across Pianos, Shrine, and Victoria NYC.",
    frequency: [
      {
        label: 'Sonic DNA',
        value: '80s post-punk, raw acoustic energy, The Bandroidz electric grit, Psychedelic Furs atmosphere, blues background, banjo texture, and deep groove.',
      },
      {
        label: 'The Spices of NYC Geography',
        value:
          'As Monk reflected in Claremont Park in the Bronx (2011), living across the East Village throughout the 1980s, the Upper West Side, Harlem, 88th Street off Columbus, and the Bronx gave his sound its cross-borough pulse.',
      },
      {
        label: 'Americana Root System',
        value:
          "Started with a banjo passed from his brother and a two-string walk home from 140th Street—blues phrasing, banjo nights, and banjo attack ground the signal, giving the punk edge a porch-floor pulse and a folk-memory undertow.",
      },
      {
        label: 'The Friends Collaboration',
        value:
          'A boom-boom songwriting chemistry: ego bypassed, collective unconscious accessed, structure found through trust.',
      },
      {
        label: 'Narrative Superpower',
        value:
          'Monk Americana moves as a recurring entity, crossing from real-world collaborator into fictionalized character work, including the Detroit-based comic book lineage.',
      },
    ],
    videoArchives: [
      {
        title: "The Bandroidz (Band Droidz) — 'Don't Believe / Favorite Sun' Live at National Underground",
        source: 'Delano Franklin Archive | National Underground NYC (159 E. Houston St, Sept. 25, 2009)',
        url: 'https://vimeo.com/6791465?fl=tl&fe=ec',
        thumbnail: '/images/transmissions/nyc/bandroidz-national-underground-2009.jpg',
        year: 2009,
        signal:
          "Monk Americana fronting The Bandroidz (Band Droidz) on Stratocaster and lead vocals at National Underground on the Lower East Side across 'Don't Believe / Favorite Sun.'",
      },
      {
        title: "The Bandroidz (Band Droidz) — 'Mountain Man' Live at Shrine Harlem",
        source: 'Delano Franklin Archive | Shrine World Music Venue, Harlem (March 2011)',
        url: 'https://vimeo.com/21657567?fl=tl&fe=ec',
        thumbnail: '/images/transmissions/nyc/bandroidz-shrine-harlem-2011.jpg',
        year: 2011,
        signal:
          "Uptown live capture at Shrine in Harlem as Monk Americana and The Bandroidz lock into 'Mountain Man.'",
      },
      {
        title: "Monk Americana (The Bandroidz) — 'The Spices of My Music' (Claremont Park Interview)",
        source: 'Delano Franklin Archive | Claremont Park, The Bronx (April 2011 · Cropped to Monk’s Answer)',
        url: 'https://vimeo.com/21858173?fl=tl&fe=ec',
        thumbnail: '/images/transmissions/nyc/bandroidz-monk-claremont-park-bronx-2011.jpg',
        year: 2011,
        signal:
          "Trimmed to open directly with Monk's answer on how New York City shaped his music—from the East Village in the early, mid-, and late '80s to Harlem, the Upper West Side, and the Bronx.",
      },
    ],
    lineage: [
      'A Gathering of Tribes: carrying the torch of the experimental and the marginalized.',
      "140th Street & Banjo Origin: A banjo passed from his brother and a two-string walk home from 140th Street that changed the direction of his life, grounding his refusal to be reduced from a musician into a content creator.",
      "The Bandroidz (Band Droidz, 2009–2011): Fronting the NYC rock-and-groove outfit across Lower East Side and Harlem stages—including 'Don't Believe / Favorite Sun' at National Underground (Sept. 25, 2009), 'Mountain Man' at Shrine in Harlem (March 2011), and the Claremont Park Bronx field interview (April 2011) filmed by Delano Franklin.",
      'Collaborative roots with Honeychild Coleman (from their early-\'90s 42nd Street Shuttle encounter and songwriting chemistry on "Friends" to The 1865 alongside drummer Jason "Biz" Lucas, bassist Flora Lucini, session legend Chuck Treece, and late co-founder Sacha Jenkins) and creative circles connected to John Farris and Darius James.',
      "Pianos NYC (158 Ludlow Street): Accompanying Honeychild Coleman (HoneyChild's DEM) with Biz on drums and special guest Jennie Oliver-Cretara (viola) for the 'I Have A Dream Pop Festival' alongside The Veldt and Burnt Sugar The Arkestra Chamber.",
      'A New York arts bridge where street encounter, literary signal, punk posture, banjo texture, and groove-based music share one rail line.',
    ],
    currentTransmission:
      "Banjo, Blues & Signal Sovereignty — Monk Americana (TogeeVision Field Transmission No. 1): starting with a banjo case opening under amber light, a banjo passed from his brother, and a two-string walk home from 140th Street, Monk draws a hard line between being a musician—sore fingers after an hour-and-a-half set, rehearsals as living documents, banjo nights, unreleased work—and being reduced to a content creator. Tracing his early-'90s 42nd Street Shuttle encounter with Honeychild Coleman and Claremont Park reflection ('the spices of my music') through 'Friends,' The Bandroidz (Band Droidz) at National Underground and Shrine Harlem, The 1865 with Honeychild and Biz, and Pianos NYC (158 Ludlow Street) for the 'I Have A Dream Pop Festival' with HoneyChild's DEM, Biz, and Jennie Oliver-Cretara.",
    crewCritique: [
      {
        speaker: 'TogeeVision',
        register: 'Fixed Point',
        line: "Monk Americana enters the NYC radar as Artist Profile No. 001 with a banjo passed from his brother and a two-string walk home from 140th Street. He is the platform thesis in human form: not content, not feed residue, but a working musician asking for a sovereign artist home where music, video, rehearsal fragments, banjo nights, and archive links stay attached to the body that made them.",
      },
      {
        speaker: 'Lex Gupta',
        register: 'Structural Read',
        line: "The lever is concrete: artist profile, protected media uploads, live rehearsal notices, private coordination, archive storage, and one QR route that sends the room back to Monk's own signal instead of another extractive platform.",
      },
      {
        speaker: 'Anansi Byte',
        register: 'Provenance Read',
        line: "The root is not branding. It is 140th Street, the early-'90s 42nd Street Shuttle, Honeychild Coleman's black acoustic guitar in combat boots and a tutu, blues memory, banjo attack, songwriting chemistry on 'Friends,' NYC boroughs Monk calls 'the spices of his music' at Claremont Park, fronting The Bandroidz from National Underground to Shrine in Harlem, The 1865 with Honeychild and Biz, Pianos on Ludlow Street with HoneyChild's DEM, Biz, and Jennie Oliver-Cretara, and the refusal to let the old labels rename a musician as a content unit.",
      },
      {
        speaker: 'Kaelen Vance',
        register: 'Blueprint Read',
        line: "Monk talks about playing real shows, sore fingers after an hour-and-a-half set, rehearsals as living documents, and banjo nights. The build is a sovereign artist channel: videos, songs, rehearsal fragments, live pop-ups, encrypted rooms, and a permanent archive that lets Monk invite people in without surrendering the work.",
      },
    ],
    closing:
      "This Transmission Chronicle lets the Tune In button play Monk Americana as a living field signal: 140th Street banjo origin, early-'90s Honeychild lineage, The Bandroidz, The 1865, Pianos NYC, live-process sovereignty, and an artist archive built against the content machine.",
    mediaArchaeology: {
      description:
        "Documents Monk Americana's multi-decade New York City signal ('Banjo, Blues & Signal Sovereignty'): his 140th Street two-string walk home with his brother's banjo, his refusal to be flattened into a content creator, his early-'90s 42nd Street Shuttle origin encounter with Honeychild Coleman, archival 2009–2011 Delano Franklin films fronting The Bandroidz at National Underground and Shrine Harlem plus his Claremont Park Bronx interview, his lineage with The 1865, and his October 24, 2026 performance with HoneyChild's DEM and Biz at Pianos NYC.",
      highlight:
        "140th St Banjo Origin & Early-'90s 42nd Street Shuttle → Banjo Nights & Signal Sovereignty → The Bandroidz (2009–2011) → The 1865 → HoneyChild's DEM w/ Monk Americana & Biz at Pianos NYC (10/24/26).",
    },
    provenance: {
      sourceAuthority: 'live_field_capture',
      eventDate: '2026-10-24',
      nodeCoordinate: 'New York Corridor — 140th Street · 42nd Street Shuttle · National Underground · Shrine Harlem · Claremont Park · Pianos NYC (158 Ludlow St)',
      capturedBy: ['Delano Franklin Archive', 'TogeeVision Field Unit'],
      sourceMaterials: [
        "TogeeVision Field Transmission No. 1 — 'Banjo, Blues & Signal Sovereignty - Monk Americana' Original Broadcast Segments (140th Street banjo walk, sore fingers, banjo nights, Caller 'The Boundary Keeper')",
        "The Bandroidz (Band Droidz) — 'Don't Believe / Favorite Sun' Live at National Underground NYC (Vimeo 6791465, Sept. 25, 2009, 00:07:31, filmed by Delano Franklin)",
        "The Bandroidz (Band Droidz) — 'Mountain Man' Live at Shrine World Music Venue Harlem (Vimeo 21657567, March 2011, 00:03:35, filmed by Delano Franklin)",
        "Monk Americana — 'The Spices of My Music' Claremont Park Bronx Interview (Vimeo 21858173, April 2011, cropped to Monk's answer at 00:00:39, filmed by Delano Franklin)",
        "HoneyChild's DEM w/ Monk Americana, Biz & Jennie Oliver-Cretara 4K Live Stage Master at Pianos NYC Upstairs Lounge (Google Drive 1So9anY1jKnYM6Zre9WnlFstMpmRYyiiL, Oct. 24, 2026)",
        "NYC Broadcast Master Audio (transmission_artist-monk-washington.mp3, 00:05:53.96, 44.1kHz stereo, SHA-256: 842148f60b08e5c6d07073115fa564c34b7835ae1023e04e39652e6a4214a540)",
      ],
      rightsStatus: 'sovereign_field_archive',
    },
    acousticTelemetry: {
      duration: '00:05:53.96',
      sampleRate: '44100 Hz',
      channels: 'stereo',
      meanVolumeDb: -14.0,
      peakVolumeDb: -1.0,
      chapters: [
        {
          chapter: 1,
          timecode: '00:00:00',
          title: "Banjo Case Under Amber Light, 140th Street Two-String Walk Home & Artist Profile No. 001",
          act: 'TogeeVision & Lex Gupta',
          energyLevelDb: -13.9,
        },
        {
          chapter: 2,
          timecode: '00:01:40',
          title: "Early-'90s 42nd Street Shuttle Origin, 'The Spices of My Music,' Friends, The Bandroidz (2009–2011) & The 1865",
          act: 'Anansi Byte & The Bandroidz (National Underground & Shrine Harlem)',
          energyLevelDb: -14.0,
        },
        {
          chapter: 3,
          timecode: '00:02:44',
          title: "Signal Sovereignty ('Not a Content Creator'), Sore Fingers, Banjo Nights & Pianos NYC ('The Salt')",
          act: "Kaelen Vance, Lex Gupta, Anansi Byte & HoneyChild's DEM w/ Monk, Biz & Jennie Oliver-Cretara",
          energyLevelDb: -13.8,
        },
        {
          chapter: 4,
          timecode: '00:04:32',
          title: "Caller Patch-In ('The Boundary Keeper'), Banjo Experiment Lineage & Sovereign Archive Sign-Off",
          act: 'Caller (The Boundary Keeper), TogeeVision, Lex Gupta, Anansi Byte & Kaelen Vance',
          energyLevelDb: -14.0,
        },
      ],
    },
    translations: {
      'fr-CA': {
        title: "Banjo, Blues et Souveraineté du Signal — Monk Americana (140e Rue, navette de la 42e Rue au début des années 90, The Bandroidz, The 1865 et Pianos NYC)",
        eyebrow: "Profil d'artiste n° 001 · Transmission de terrain n° 1",
        subject: 'Monk Americana (Banjo / Blues / The Bandroidz / The 1865 / HoneyChild\'s DEM)',
        status: 'Transmission de terrain active — Corridor NYC',
        transmission: "Banjo, Blues et Souveraineté du Signal — Monk Americana (Origine au banjo sur la 140e Rue, navette de la 42e Rue au début des années 90, The Bandroidz, The 1865 et Pianos NYC)",
        summary:
          "Monk Americana ancre la Transmission de terrain n° 1 de TogeeVision (« Banjo, Blues & Signal Sovereignty ») : un signal enraciné dans le blues, porté par le banjo transmis par son frère et une marche de retour sur deux cordes depuis la 140e Rue, les doigts endoloris après une heure et demie de scène, les soirées banjo et le refus d'être réduit à un créateur de contenu. De sa rencontre fondatrice au début des années 1990 avec Honeychild Coleman dans la navette de la 42e Rue jusqu'à son groupe The Bandroidz (National Underground en 2009, Shrine à Harlem et le parc Claremont dans le Bronx en 2011), The 1865 aux côtés de Honeychild et Biz, et Pianos NYC (158, rue Ludlow) le 24 octobre 2026 pour le festival « I Have A Dream Pop ».",
        crewCritique: [
          {
            speaker: 'TogeeVision',
            register: 'Fixed Point',
            line: "Monk Americana entre sur le radar new-yorkais comme Profil d'artiste n° 001 avec un banjo transmis par son frère et une marche de retour sur deux cordes depuis la 140e Rue. Il incarne la thèse de la plateforme sous forme humaine : non pas du contenu, mais un musicien demandant un foyer souverain où le signal reste attaché au corps qui l'a créé.",
          },
          {
            speaker: 'Lex Gupta',
            register: 'Structural Read',
            line: "Le levier est concret : profil d'artiste, téléversements protégés, avis de répétitions en direct, coordination privée, stockage d'archives et un parcours QR qui renvoie la salle vers le propre signal de Monk.",
          },
          {
            speaker: 'Anansi Byte',
            register: 'Provenance Read',
            line: "La racine n'est pas le marketing : c'est la 140e Rue, la navette de la 42e Rue au début des années 90, la guitare acoustique noire de Honeychild Coleman, la mémoire du blues, l'attaque du banjo, les quartiers new-yorkais que Monk appelle « les épices de ma musique » au parc Claremont, The Bandroidz du National Underground au Shrine à Harlem, The 1865 avec Honeychild et Biz, et Pianos sur la rue Ludlow.",
          },
          {
            speaker: 'Kaelen Vance',
            register: 'Blueprint Read',
            line: "Monk parle des vrais concerts, des doigts endoloris après une heure et demie de jeu, des répétitions comme documents vivants et des soirées banjo : un canal d'artiste souverain et une archive permanente.",
          },
        ],
        closing:
          "Cette chronique de transmission fait entendre Monk Americana comme un signal de terrain vivant : origine au banjo sur la 140e Rue, lignée avec Honeychild dès le début des années 90, The Bandroidz, The 1865, Pianos NYC et souveraineté artistique contre la machine à contenu.",
        mediaArchaeology: {
          description:
            "Documente le signal new-yorkais de Monk Americana (« Banjo, Blues & Signal Sovereignty ») : son origine au banjo sur la 140e Rue, son refus d'être réduit à un créateur de contenu, sa rencontre avec Honeychild Coleman au début des années 90 dans la navette de la 42e Rue, les films d'archives de Delano Franklin avec The Bandroidz (2009–2011), The 1865 et sa performance du 24 octobre 2026 chez Pianos NYC.",
          highlight:
            "Origine au banjo sur la 140e Rue & navette de la 42e Rue (début des années 90) → Soirées banjo & Souveraineté du signal → The Bandroidz (2009–2011) → The 1865 → Pianos NYC avec HoneyChild's DEM et Biz (24/10/26).",
        },
      },
    },
    integration: {
      title: 'Integration Strategy',
      body:
        'This profile links Monk Americana across Pianos NYC (158 Ludlow Street), Shrine World Music Venue in Harlem, and Victoria NYC (235 Eldridge Street) on the NYC Signal Radar.',
    },
    community: {
      matrix: {
        enabled: true,
        guestAccess: false,
        roomAlias: '#monk-americana:togeevision.com',
        joinUrl: 'https://matrix.to/#/#monk-americana:togeevision.com',
        label: 'Join Monk Americana’s Signal Channel',
        requiresTogeeVisionLogin: true,
      },
    },
    upcomingNodes: [
      {
        date: 'OCTOBER 24, 2026',
        isoDate: '2026-10-24T20:30:00-04:00',
        venue: "Pianos NYC — 'I Have A Dream Pop Festival' (HoneyChild's DEM w/ Monk Americana)",
        city: '158 Ludlow Street, Lower East Side, New York, NY',
        time: 'Saturday · 8:30 PM',
        eventId: 'demo-event-nyc-pianos-honeychild-monk-2026',
        venueId: 'venue-pianos-nyc',
        transmissionPath: '/passport/transmissions/artist-honeychild-coleman',
        transmissionLabel: 'Open Pianos Show w/ Honeychild Transmission →',
        posterUrl: '/images/transmissions/nyc/pianos-ludlow-marquee-dream-pop.jpg',
        notes: "Accompanying Honeychild Coleman (HoneyChild's DEM) at Pianos on Ludlow St alongside The Veldt and Burnt Sugar The Arkestra Chamber.",
      },
      {
        date: 'SUNDAYS · RECURRING',
        venue: "Miwi's Music Thing at Victoria NYC",
        city: '235 Eldridge Street, New York, NY',
        time: 'Sunday Session 4:30–7:00 PM',
        eventId: 'event-miwi-music-thing-victoria-nyc-2026-09-13',
        posterUrl: '/images/miwi-music-thing-victoria-nyc-2026-09-13.jpg',
        notes: 'Live collaboration and songwriter catalog sessions with Miwi La Lupa at Victoria NYC',
      },
    ],
  },
  'honeychild-coleman': {
    id: 'honeychild-coleman',
    profileNumber: '002',
    name: 'Honeychild Coleman',
    role: 'Artist / Musician / Collage Signal',
    city: 'nyc',
    status: 'Field Transmission Active — Pianos NYC',
    transmission: "Pianos NYC: 'I Have A Dream Pop Festival' — HoneyChild's DEM w/ Monk Americana & Jennie Oliver-Cretara (10/24/26)",
    transmissionChronicleAudioUrl: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/audio/transmission_artist-honeychild-coleman.mp3',
    fallbackAudioUrl: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/audio/transmission_artist-honeychild-coleman.mp3',
    carriers: {
      en: {
        audioUrl: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/audio/transmission_artist-honeychild-coleman.mp3',
        audioReady: true,
      },
      'fr-CA': {
        audioUrl: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/audio/transmission_artist-honeychild-coleman_fr-ca.mp3',
        audioReady: true,
      },
    },
    transmissionType: 'Field Transmission Active',
    landingPath: '/nyc',
    landingLabel: 'NYC Page',
    radarPath: '/passport/radar?city=nyc',
    associatedVenueIds: ['pianos-nyc', 'kismat-washington-heights', 'melophobe-bk'],
    image: '/images/transmissions/nyc/pianos-honeychild-dem-monk-green-room.jpg',
    imageAlt: "Pianos NYC Green Room portrait (left to right): Monk Americana, Honeychild Coleman, Jennie Olivera-Cretara, and drummer Jason 'Biz' Lucas (The 1865) during the 'I Have A Dream Pop Festival' (October 24, 2026)",
    imageCaption: "Pianos NYC Green Room portrait at 158 Ludlow Street during the 'I Have A Dream Pop Festival' (October 24, 2026) — left to right: Monk Americana, Honeychild Coleman (HoneyChild's DEM / The 1865), Jennie Olivera-Cretara, and drummer Jason 'Biz' Lucas (The 1865).",
    imagePosition: 'center 35%',
    tags: ['Sistagrrl Riots', "HoneyChild's DEM", 'The 1865', 'Jason "Biz" Lucas', 'Honeychild & Biz', "Don't Tread On We!", 'Pianos NYC', 'I Have A Dream Pop Festival', 'The Salt', 'Jennie Oliver-Cretara', 'Afro-Futurist', 'Blues-Punk', 'Zines', 'PunkCon 2026'],
    origin: {
      title: 'The Legacy Transmission',
      subtitle: 'Archive No. 2008-2010 & Pianos 10/24/26',
      body:
        "Honeychild Coleman carries the foundational boom-boom collaboration between the artist and TogeeVision creative direction. From Digital Hi-8 Brooklyn tea-shop sessions and her post-Emancipation Afro-punk collective The 1865 (with drummer Jason 'Biz' Lucas) to commanding Pianos Upstairs Lounge at 158 Ludlow Street with HoneyChild's DEM, Monk Americana, and Biz, the archive captures the Entity without the noise of commercial over-production.",
      note:
        'The signal is loudest in the intimate, low-fi moments—and when the room locks into a continuous dub-shoegaze groove.',
    },
    summary:
      "Honeychild Coleman documents the bridge from zine culture to reel culture and live sonic insurgency: handmade collage, baritone guitar, blues-punk velocity, shoegaze dub, and direct field capture. Alongside drummer Jason 'Biz' Lucas, she fronts The 1865—whose name and music explore the massive parallels between modern systemic issues and life post-Emancipation in the shadow of the fallen Confederacy (breakout debut LP 'Don't Tread On We!' on Mass Appeal Records; 2024 single 'Blitzkrieg Cops'; alumni including Monk Americana, bassist Flora Lucini, session legend Chuck Treece, and late co-founder Sacha Jenkins)—and frequently operates as the live duo 'Honeychild & Biz' across Brooklyn and Manhattan rooms like Sleepwalk, Pianos, and P.I.T. On Saturday, October 24, 2026 at Pianos NYC Upstairs Lounge (158 Ludlow Street on the Lower East Side), she commands the stage as HoneyChild's DEM with Monk Americana and Biz for the 'I Have A Dream Pop Festival' founded by Daniel and Danny Chavis of The Veldt—delivering a continuous seven-song set ('Echelon,' 'Drug Bags & Leaves,' 'December,' 'Takeover,' 'Heelspur Whisper,' 'Circumstances,' and 'The Salt' featuring special guest Jennie Oliver-Cretara on viola).",
    frequency: [
      {
        label: "HoneyChild's DEM Live Architecture (10/24/26)",
        value:
          "Seven-song continuous Pianos NYC Upstairs Lounge set with Monk Americana and Biz: 'Echelon' (Loop 'It's Understood') → 'Drug Bags & Leaves' (Starts with Biz) → 'December' (noise trail transition) → 'Takeover' → 'Heelspur Whisper' → 'Circumstances' → 'The Salt' (featuring Jennie Oliver-Cretara on viola).",
      },
      {
        label: 'The 1865 & "Honeychild & Biz"',
        value:
          "Exploring the massive parallels between modern systemic issues and life post-Emancipation in the shadow of the fallen Confederacy. Led by vocalist/baritone guitarist Honeychild Coleman and drummer Jason 'Biz' Lucas (with lineage featuring Monk Americana, bassist Flora Lucini, session legend Chuck Treece, and late co-founder Sacha Jenkins). Notable work includes debut LP 'Don't Tread On We!' (Mass Appeal Records) and 2024 single 'Blitzkrieg Cops,' plus frequent live duo sets ('Honeychild & Biz') at Sleepwalk, Pianos, and P.I.T.",
      },
      {
        label: 'Minimalist Kismet',
        value:
          'Raw, intimate capture before the digital age muffled the frequency: tea shop light, direct presence, no club-scale overbuild.',
      },
      {
        label: 'Zine-to-Reel Energy',
        value:
          'Intertextual collage, physical stickers, punk pedagogy, and video documentation moving as one working method.',
      },
      {
        label: 'Punk Pedagogies & Scholastic Sabotage',
        value:
          'From UNLV symposiums to grassroots street tables: mobilizing zines, stencils, and tape cassettes as living counter-curricula.',
      },
    ],
    lineage: [
      "Pianos NYC Upstairs Lounge (158 Ludlow Street, Oct 24, 2026): Performing a 7-song continuous set as HoneyChild's DEM accompanied by Monk Americana, Biz on drums, and special guest Jennie Oliver-Cretara (viola on 'The Salt') at the 'I Have A Dream Pop Festival' curated by Daniel and Danny Chavis of The Veldt.",
      "The 1865 ('Don't Tread On We!' & 'Blitzkrieg Cops'): Post-Emancipation Afro-punk and shoegaze collective featuring lead vocalist/baritone guitarist Honeychild Coleman and drummer Jason 'Biz' Lucas—with alumni Monk Americana, bassist Flora Lucini, session legend Chuck Treece, and late co-founder Sacha Jenkins—and operating frequently as the live duo 'Honeychild & Biz' across Sleepwalk, Pianos, and P.I.T.",
      'Legacy Asset 01: Gracefully, captured on Digital Hi-8 in a Brooklyn tea shop and sourced from Halo Inside (Come la Luna) on Matteite Records.',
      'Legacy Asset 02: Orange - Honeychild Coleman, a 2009 Delano Franklin video remix with MilkDrop visuals from the Halo Inside (Come la Luna) archive.',
      'The Tea Shop Model proves the efficiency of one-to-one creative capture.',
      'The aspirational lesson from Halo Inside confirms that the Entity is preserved through direct, intuitive cinematography.',
      'PunkCon 2026 (UNLV): "Teaching for the Masses: Punk Pedagogies for Scholastic Saboteurs" and "From Zines to Reels" workshop.',
    ],
    videoArchives: [
      {
        title: "HoneyChild's DEM w/ Monk Americana & Biz — Live at Pianos NYC Upstairs Lounge (Saturday Night Clip I)",
        source: "I Have A Dream Pop Festival | Pianos NYC (158 Ludlow St, 10/24/26)",
        url: 'https://docs.google.com/videos/d/1qHQEHzuGGaaraJjhmIyjaZRXo0hxPN8xpSgkl3_zEOI/play?usp=sharing',
        thumbnail: '/images/transmissions/nyc/pianos-honeychild-dem-monk-stage-red.jpg',
        year: 2026,
        signal:
          "Saturday night live field video capture (IMG_3207) of Honeychild Coleman (HoneyChild's DEM) accompanied by Monk Americana and Biz inside Pianos Upstairs Lounge.",
      },
      {
        title: "HoneyChild's DEM w/ Monk Americana, Biz & Jennie Oliver-Cretara — 'The Salt' Live at Pianos NYC (Saturday Night Clip II)",
        source: "I Have A Dream Pop Festival | Pianos NYC (158 Ludlow St, 10/24/26)",
        url: 'https://docs.google.com/videos/d/1DxnuNZmyvx6XaJJEPIGwuq_Q4UY5-RKzt6WBxmgMyvA/play?usp=sharing',
        thumbnail: '/images/transmissions/nyc/pianos-honeychild-dem-the-salt-viola.jpg',
        year: 2026,
        signal:
          "Saturday night 4K live stage capture (PXL_20261025_003408137) of 'The Salt' featuring special guest Jennie Oliver-Cretara on viola with HoneyChild's DEM, Monk Americana, and Biz.",
      },
      {
        title: "HoneyChild's DEM w/ Monk Americana & Biz — Live at Pianos NYC Upstairs Lounge (Saturday Night Clip III)",
        source: "I Have A Dream Pop Festival | Pianos NYC (158 Ludlow St, 10/24/26)",
        url: 'https://docs.google.com/videos/d/1CYlQdBHyrkXJM_UVtJpzTLSPyVUCbCotMknqgZW8aFQ/play?usp=sharing',
        thumbnail: '/images/transmissions/nyc/pianos-honeychild-dem-monk-disco-ball.jpg',
        year: 2026,
        signal:
          "Saturday night live stage capture (IMG_3208) of Honeychild Coleman, Monk Americana, and Biz under crimson neon and mirror-ball reflections at Pianos NYC Upstairs Lounge.",
      },
      {
        title: "HoneyChild's DEM w/ Monk Americana & Biz — Live at Pianos NYC Upstairs Lounge (Saturday Night Clip IV)",
        source: "I Have A Dream Pop Festival | Pianos NYC (158 Ludlow St, 10/24/26)",
        url: 'https://docs.google.com/videos/d/13VF0mI1ljMCaahOQ9XnE4KgscByzYxdPAi0pFqwI9Ok/play?usp=sharing',
        thumbnail: '/images/transmissions/nyc/pianos-honeychild-dem-quartet-wide.jpg',
        year: 2026,
        signal:
          "Saturday night live stage capture (IMG_3209) of HoneyChild's DEM, Monk Americana, and Biz driving the continuous 7-song dub-shoegaze and blues-punk set at Pianos NYC.",
      },
      {
        title: 'Gracefully',
        source: 'Halo Inside (Come la Luna) | Matteite Records',
        url: 'https://youtu.be/zbu5E_aUw90',
        year: 2008,
        signal:
          'Captured on Digital Hi-8 in a Brooklyn tea shop. The blueprint for Minimalist Kismet.',
      },
      {
        title: 'Orange - Honeychild Coleman',
        source: 'YouTube Archive | Delano Franklin video remix',
        url: 'https://youtu.be/nCyHWeRWnwk',
        year: 2009,
        signal:
          'A remixed visual signal for Orange, sourced from Halo Inside (Come la Luna), Matteite Records 2008, with MilkDrop plugin visuals.',
      },
    ],
    visualAssets: [
      {
        id: 'photo-pianos-honeychild-dem-monk-green-room',
        type: 'image',
        src: '/images/transmissions/nyc/pianos-honeychild-dem-monk-green-room.jpg',
        title: 'Pianos NYC Green Room: Monk Americana, Honeychild Coleman, Jennie Olivera-Cretara & Biz',
        caption: "Backstage portrait inside the Pianos NYC Green Room at 158 Ludlow Street on Saturday, October 24, 2026 during the 'I Have A Dream Pop Festival' (left to right): Monk Americana, Honeychild Coleman, Jennie Olivera-Cretara, and drummer Jason “Biz” Lucas (The 1865).",
      },
      {
        id: 'photo-pianos-honeychild-dem-monk-stage-red',
        type: 'image',
        src: '/images/transmissions/nyc/pianos-honeychild-dem-monk-stage-red.jpg',
        title: "HoneyChild's DEM, Monk Americana & Biz Live at Pianos Upstairs Lounge",
        caption: "Live stage capture under crimson light and disco ball reflections at Pianos NYC Upstairs Lounge (158 Ludlow Street, October 24, 2026) — left to right: Monk Americana on Stratocaster and tabletop sampler in front of his Vox amplifier, Honeychild Coleman (HoneyChild's DEM) at center mic, and Biz on the Sonor drum kit.",
      },
      {
        id: 'photo-pianos-honeychild-dem-setlist-2026-10-24',
        type: 'image',
        src: '/images/transmissions/nyc/pianos-honeychild-dem-setlist-2026-10-24.jpg',
        title: "HONEYCHILD COLEMAN's DEM — Pianos Stage Setlist (10/24/26)",
        caption: "Printed stage setlist on the wooden floor at Pianos for the 'I Have A Dream Pop Festival (NYC) 10/24/26': 1. Echelon (Loop 'It's Understood'), 2. Drug Bags & Leaves (Starts with Biz), 3. December (Starts with noise trail out from Drug Bags & Leaves), 4. Takeover (Sustained notes from December trail into Takeover), 5. Heelspur Whisper, 6. Circumstances, 7. The Salt (Special guest on viola Jennie Oliver-Cretara).",
      },
      {
        id: 'photo-pianos-dream-pop-festival-poster-2026-10-24',
        type: 'image',
        src: '/images/transmissions/nyc/pianos-i-have-a-dream-pop-festival-poster-2026-10-24.png',
        title: "I Have A Dream Pop Festival (Sat. 10/24/26 NYC) Official Poster",
        caption: "Official Saturday 10/24/26 NYC poster for the 'I Have A Dream Pop Festival' at Pianos (158 Ludlow St., L.E.S., NYC) featuring The Veldt, Burnt Sugar (NYC), Honeychild Coleman's DEM (NYC), Spirit Hotel, Mahogany, Faith, Cigarettes For Breakfast, Lovina Falls, Dead Leaf Echo, The Moonbugs, Phantom Wave, Bandy, Weegee, The Shining Hours, Iceblynk, and DJ Voidsong.",
      },
      {
        id: 'photo-pianos-honeychild-dem-monk-disco-ball',
        type: 'image',
        src: '/images/transmissions/nyc/pianos-honeychild-dem-monk-disco-ball.jpg',
        title: "Crimson Mirror Ball & Dub-Shoegaze Pulse at Pianos NYC",
        caption: "Second stage angle from Pianos Upstairs Lounge as emerald and ruby disco ball reflections cut across Honeychild Coleman, Monk Americana, and Biz during Saturday night of the 'I Have A Dream Pop Festival.'",
      },
      {
        id: 'photo-pianos-honeychild-dem-the-salt-viola',
        type: 'image',
        src: '/images/transmissions/nyc/pianos-honeychild-dem-the-salt-viola.jpg',
        title: "'The Salt' Finale Featuring Special Guest Jennie Oliver-Cretara on Viola",
        caption: "4K field capture still from the closing piece 'The Salt' at Pianos Upstairs Lounge, showing special guest Jennie Oliver-Cretara bowing viola in silhouette facing Honeychild Coleman on guitar and Biz on the Sonor drum kit.",
      },
      {
        id: 'photo-pianos-honeychild-dem-quartet-wide',
        type: 'image',
        src: '/images/transmissions/nyc/pianos-honeychild-dem-quartet-wide.jpg',
        title: "Full Ensemble Stage Geometry Inside Pianos Upstairs Lounge",
        caption: "Wide-angle 4K capture of the full Pianos Upstairs Lounge stage under diagonal red neon ceiling strips as HoneyChild's DEM, Monk Americana, Biz, and violist Jennie Oliver-Cretara drive 'The Salt' to its crescendo.",
      },
      {
        id: 'photo-pianos-ludlow-marquee-dream-pop',
        type: 'image',
        src: '/images/transmissions/nyc/pianos-ludlow-marquee-dream-pop.jpg',
        title: "Pianos Storefront Marquee at 158 Ludlow Street",
        caption: "The historic white storefront sign at 158 Ludlow Street on the Lower East Side ('NEW & USED BOUGHT & SOLD — PIANOS') during the 'I Have A Dream Pop Festival.'",
      },
    ],
    gallery: [
      {
        id: 'honeychild-gallery-pianos-green-room',
        url: '/images/transmissions/nyc/pianos-honeychild-dem-monk-green-room.jpg',
        title: 'Pianos NYC Green Room — Monk Americana, Honeychild Coleman, Jennie Olivera-Cretara & Biz (10/24/26)',
        alt: 'Monk Americana, Honeychild Coleman, Jennie Olivera-Cretara, and Biz backstage in the Pianos NYC Green Room',
        caption: "Backstage inside the Pianos NYC Green Room (158 Ludlow Street) during Saturday night of the 'I Have A Dream Pop Festival' (left to right): Monk Americana, Honeychild Coleman, Jennie Olivera-Cretara, and drummer Jason “Biz” Lucas (The 1865).",
        date: 'October 24, 2026 · Pianos NYC Green Room',
      },
      {
        id: 'honeychild-gallery-pianos-stage-red',
        url: '/images/transmissions/nyc/pianos-honeychild-dem-monk-stage-red.jpg',
        title: "HoneyChild's DEM, Monk Americana & Biz Live at Pianos NYC (10/24/26)",
        alt: "Left to right: Monk Americana on guitar, Honeychild Coleman at center mic, and Biz on drums at Pianos Upstairs Lounge",
        caption: "Live stage capture at Pianos Upstairs Lounge (158 Ludlow Street) for Saturday night of the 'I Have A Dream Pop Festival' (left to right): Monk Americana on guitar and live electronics, Honeychild Coleman at center mic, and Biz on the Sonor drum kit.",
        date: 'October 24, 2026 · Pianos NYC',
      },
      {
        id: 'honeychild-gallery-pianos-setlist',
        url: '/images/transmissions/nyc/pianos-honeychild-dem-setlist-2026-10-24.jpg',
        title: "HONEYCHILD COLEMAN's DEM — Pianos Stage Setlist (10/24/26)",
        alt: "Printed 7-song setlist on the Pianos stage floor for Honeychild Coleman's DEM at I Have A Dream Pop Festival",
        caption: "Printed stage setlist on the wooden floor at Pianos: Echelon, Drug Bags & Leaves (Starts with Biz), December, Takeover, Heelspur Whisper, Circumstances, and The Salt (w/ special guest Jennie Oliver-Cretara on viola).",
        date: 'October 24, 2026 · Pianos NYC',
      },
      {
        id: 'honeychild-gallery-pianos-dream-pop-poster',
        url: '/images/transmissions/nyc/pianos-i-have-a-dream-pop-festival-poster-2026-10-24.png',
        title: "I Have A Dream Pop Festival (Sat. 10/24/26 NYC) Official Poster",
        alt: "I Have A Dream Pop Festival Saturday 10/24/26 NYC poster at Pianos featuring The Veldt, Burnt Sugar, and Honeychild Coleman's DEM",
        caption: "Official Saturday 10/24/26 NYC poster for the 'I Have A Dream Pop Festival' at Pianos (158 Ludlow St., L.E.S.) featuring The Veldt, Burnt Sugar (NYC), Honeychild Coleman's DEM (NYC), and full festival lineup.",
        date: 'October 24, 2026 · Pianos NYC',
      },
      {
        id: 'honeychild-gallery-pianos-the-salt-viola',
        url: '/images/transmissions/nyc/pianos-honeychild-dem-the-salt-viola.jpg',
        title: "'The Salt' w/ Special Guest Jennie Oliver-Cretara on Viola & Biz on Drums",
        alt: "Jennie Oliver-Cretara playing viola onstage with Honeychild Coleman and Biz at Pianos NYC",
        caption: "Special guest Jennie Oliver-Cretara on viola joining HoneyChild's DEM, Monk Americana, and Biz for the closing track 'The Salt' at Pianos Upstairs Lounge.",
        date: 'October 24, 2026 · Pianos NYC',
      },
      {
        id: 'honeychild-gallery-pianos-dream-pop-marquee',
        url: '/images/transmissions/nyc/pianos-ludlow-marquee-dream-pop.jpg',
        title: "Pianos NYC: 'I Have A Dream Pop Festival' Marquee (158 Ludlow St)",
        alt: "Pianos storefront marquee at 158 Ludlow Street during the 'I Have A Dream Pop Festival'",
        caption: "Pianos storefront marquee at 158 Ludlow Street on the Lower East Side for the 'I Have A Dream Pop Festival,' where Honeychild Coleman performs as HoneyChild's DEM accompanied by Monk Americana.",
        date: 'October 24, 2026 · Pianos NYC',
      },
      {
        id: 'honeychild-gallery-lounge-trio',
        url: '/images/honeychild-coleman/honeychild-coleman-lounge-trio.jpg',
        title: 'Minimalist Kismet Encounter',
        alt: 'Honeychild Coleman with collaborators in New York',
        caption: 'Honeychild Coleman (foreground) with collaborators — intimate, low-fi encounter embodying the Minimalist Kismet philosophy.',
        date: 'NYC Field Capture',
      },
      {
        id: 'honeychild-gallery-punkcon-workshop',
        url: '/images/honeychild-coleman/honeychild-coleman-punkcon-2026-zine-workshop-table.jpg',
        title: "From 'Zines to Reels Workshop Table",
        alt: 'PunkCon 2026 Zine Workshop table with flyers, zines, and stencils',
        caption: 'Handmade zines ("This Hotel Life", "Music is the Weapon Vol. 1"), stencils, and workshop flyer for "From \'Zines to Reels: Collage and Design As Way of Life Expression" at PunkCon 2026.',
        date: 'May 8, 2026 · PunkCon Las Vegas',
      },
      {
        id: 'honeychild-gallery-unlv-panel',
        url: '/images/honeychild-coleman/honeychild-coleman-punkcon-2026-unlv-panel.jpg',
        title: 'UNLV Punk Pedagogies Panel',
        alt: 'PunkCon 2026 panel symposium at University of Nevada, Las Vegas',
        caption: 'Panel symposium at University of Nevada, Las Vegas (UNLV): "Teaching for the Masses: Punk Pedagogies for Scholastic Saboteurs" (May 7–8, 2026).',
        date: 'May 7–8, 2026 · UNLV',
      },
      {
        id: 'honeychild-gallery-punkcon-crew',
        url: '/images/honeychild-coleman/honeychild-coleman-punkcon-2026-crew-outdoor.jpg',
        title: 'PunkCon 2026 Assembly',
        alt: 'Honeychild Coleman with Black punk & alt-culture delegates at PunkCon 2026 in Las Vegas',
        caption: 'Honeychild Coleman with fellow Black punk, alt-culture, and Sista Grrrl delegates gathering at PunkCon 2026 in Las Vegas.',
        date: 'May 2026 · Las Vegas',
      },
      {
        id: 'honeychild-gallery-spotify-playlist',
        url: '/images/honeychild-coleman/honeychild-coleman-punkcon-2026-spotify-playlist.jpg',
        title: 'PunkCon Companion Set (DJ Sugarfree BK)',
        alt: 'Spotify playlist: PunkCon 2026 w/ Honeychild Coleman curated by DJ Sugarfree BK',
        caption: 'Official 60-track companion playlist curated by DJ Sugarfree BK (Honeychild Coleman) featuring Alice Bag, Tamar-Kali, and foundational blues-punk signals.',
        date: 'May 2026 · Spotify Playlist',
      },
    ],
    crewCritique: [
      {
        speaker: 'TogeeVision',
        register: 'Fixed Point',
        line: "Saturday night, October 24, 2026 inside Pianos Upstairs Lounge at 158 Ludlow Street. Underneath crimson neon ceiling strips and a spinning mirror ball scattering emerald and ruby light across the wooden floorboards, Honeychild Coleman steps to the microphone with her dub-shoegaze and blues-punk ensemble, HoneyChild's DEM, accompanied by Monk Americana on guitar and live electronics and drummer Jason 'Biz' Lucas (The 1865) on the Sonor drum kit for night two of the 'I Have A Dream Pop Festival.'",
      },
      {
        speaker: 'Lex Gupta',
        register: 'Structural Read',
        line: "Taped directly to the Pianos stage floor beside the pedalboard, the printed October 24 setlist maps a seven-song architecture engineered for continuous sonic flow: 'Echelon' (built over the vocal loop 'It's Understood') drops into 'Drug Bags & Leaves' (Starts with Biz), whose noise trail bleeds into 'December' and sustained notes into 'Takeover,' followed by a brief thank-you before 'Heelspur Whisper' trails into 'Circumstances' and culminates in 'The Salt.'",
      },
      {
        speaker: 'Anansi Byte',
        register: 'Provenance Read',
        line: "Monk Americana, Biz, and Honeychild Coleman carry a deep New York underground lineage—from Honeychild and Monk's early-'90s encounter on the 42nd Street Shuttle to The 1865 (exploring life post-Emancipation in the shadow of the fallen Confederacy across 'Don't Tread On We!' on Mass Appeal Records and 2024's 'Blitzkrieg Cops,' alongside alumni Flora Lucini, Chuck Treece, and late co-founder Sacha Jenkins, plus live 'Honeychild & Biz' duo sets at Sleepwalk, Pianos, and P.I.T.). For the seventh and final piece, 'The Salt,' they welcome special guest Jennie Oliver-Cretara on viola, her bowed strings cutting through electric guitars, bass, and Biz's Sonor drums in a four-minute-and-thirty-two-second dub-shoegaze crescendo.",
      },
      {
        speaker: 'Kaelen Vance',
        register: 'Blueprint Read',
        line: "Acoustic telemetry logged at 44.1kHz stereo, -14.0 LUFS integrated loudness, and -1.0 dBFS true peak, weaving 4K Pixel 9 stage audio (1So9anY1jKnYM6Zre9WnlFstMpmRYyiiL) and dual Pixel Recorder field tapes (525abd55-51db-434e-b0ae-36b6653ce7aa, b1c2523d-004d-4317-a47d-7ab301777656) from Pianos Upstairs Lounge into a permanent artist-and-room broadcast record.",
      },
    ],
    closing:
      "From the early-'90s 42nd Street Shuttle, The 1865 ('Don't Tread On We!'), and Brooklyn Hi-8 tea-shop sessions to Pianos Upstairs Lounge at 158 Ludlow Street: keep the loop running, honor the lineage, and let 'The Salt' resonate.",
    mediaArchaeology: {
      description:
        "Documents Honeychild Coleman's Saturday, October 24, 2026 performance as HoneyChild's DEM accompanied by Monk Americana, Biz, and special guest violist Jennie Oliver-Cretara inside the Upstairs Lounge at Pianos NYC (158 Ludlow Street) during the 'I Have A Dream Pop Festival,' bridging Sista Grrrl blues-punk, The 1865's post-Emancipation Afro-punk lineage, dub-shoegaze, and PunkCon zine pedagogy.",
      highlight:
        "Pianos NYC Upstairs Lounge (10/24/26): HoneyChild's DEM w/ Monk Americana, Biz & Jennie Oliver-Cretara (viola) — 7-song continuous set ('Echelon' through 'The Salt').",
    },
    provenance: {
      sourceAuthority: 'live_field_capture',
      eventDate: '2026-10-24',
      nodeCoordinate: 'Pianos NYC — Upstairs Lounge (158 Ludlow Street, Lower East Side, New York, NY 10002)',
      capturedBy: ['TogeeVision Field Unit'],
      sourceMaterials: [
        "HoneyChild's DEM 4K HEVC Live Stage Master at Pianos Upstairs Lounge (Google Drive 1So9anY1jKnYM6Zre9WnlFstMpmRYyiiL, 00:04:32.34, 3840x2160 30fps + 48kHz stereo AAC, GPS +40.7210-73.9878, SHA-256: 6c4cc6b35b60fdc1c48ca4a9e1bf5d78690154f01ea1acfd476c6ff4e9230d3e)",
        "Google Pixel Recorder Field Capture I — Pianos NYC Upstairs Lounge (https://recorder.google.com/525abd55-51db-434e-b0ae-36b6653ce7aa)",
        "Google Pixel Recorder Field Capture II — Pianos NYC Upstairs Lounge (https://recorder.google.com/b1c2523d-004d-4317-a47d-7ab301777656)",
        "HONEYCHILD COLEMAN's DEM Printed Stage Setlist Artifact — I Have A Dream Pop Festival (NYC) 10/24/26 (/images/transmissions/nyc/pianos-honeychild-dem-setlist-2026-10-24.jpg)",
        "Pianos Upstairs Lounge Live Stage & Green Room Photographs (/images/transmissions/nyc/pianos-honeychild-dem-monk-stage-red.jpg, pianos-honeychild-dem-monk-green-room.jpg, pianos-honeychild-dem-monk-disco-ball.jpg, pianos-honeychild-dem-the-salt-viola.jpg, pianos-honeychild-dem-quartet-wide.jpg)",
        "NYC Broadcast Master Audio (transmission_artist-honeychild-coleman.mp3, 00:03:46.66, 44.1kHz stereo, SHA-256: bbfd7fa18fb8bc0c891bd980f0c772b119cd8ae3efb0719348219f868a940e27)",
      ],
      rightsStatus: 'sovereign_field_archive',
    },
    acousticTelemetry: {
      duration: '00:03:46.66',
      sampleRate: '44100 Hz',
      channels: 'stereo',
      meanVolumeDb: -14.0,
      peakVolumeDb: -1.0,
      chapters: [
        {
          chapter: 1,
          timecode: '00:00:00',
          title: "Pianos Upstairs Lounge Lock: HoneyChild's DEM, Monk Americana & Biz Under the Crimson Mirror Ball",
          act: "TogeeVision, HoneyChild's DEM, Monk Americana & Biz",
          energyLevelDb: -13.8,
        },
        {
          chapter: 2,
          timecode: '00:00:57',
          title: "The Seven-Song Stage Sheet: 'Echelon,' 'Drug Bags & Leaves' (Starts with Biz), 'December,' 'Takeover,' 'Heelspur Whisper' & 'Circumstances'",
          act: "Lex Gupta & HoneyChild's DEM",
          energyLevelDb: -14.0,
        },
        {
          chapter: 3,
          timecode: '00:01:50',
          title: "From the Early-'90s 42nd Street Shuttle & The 1865 to 'The Salt' Featuring Jennie Oliver-Cretara on Viola",
          act: 'Anansi Byte, Honeychild Coleman, Monk Americana, Biz & Jennie Oliver-Cretara',
          energyLevelDb: -13.9,
        },
        {
          chapter: 4,
          timecode: '00:02:55',
          title: 'Sovereign Field Telemetry, Sista Grrrl Lineage & Pianos Sign-Off',
          act: 'Kaelen Vance & TogeeVision',
          energyLevelDb: -14.0,
        },
      ],
    },
    translations: {
      'fr-CA': {
        title: "Honeychild Coleman (HoneyChild's DEM), Monk Americana & Biz : Chronique de transmission chez Pianos NYC",
        eyebrow: "Profil d'artiste n° 002 · Festival « I Have A Dream Pop » (24 oct. 2026)",
        subject: "Honeychild Coleman (HoneyChild's DEM), Monk Americana & Biz",
        status: 'Transmission de terrain active — Pianos NYC',
        transmission: "Pianos NYC : « I Have A Dream Pop Festival » — HoneyChild's DEM avec Monk Americana, Biz et Jennie Oliver-Cretara (24/10/26)",
        summary:
          "Transmission de terrain du samedi 24 octobre 2026 dans le salon à l'étage de Pianos NYC (158, rue Ludlow, Lower East Side) captant Honeychild Coleman et sa formation dub-shoegaze et blues-punk HoneyChild's DEM accompagnée par Monk Americana et le batteur Jason « Biz » Lucas (The 1865) lors du festival « I Have A Dream Pop » — avec une feuille de route continue en sept morceaux (« Echelon », « Drug Bags & Leaves », « December », « Takeover », « Heelspur Whisper », « Circumstances » et « The Salt » avec l'invitée spéciale Jennie Oliver-Cretara à l'alto).",
        crewCritique: [
          {
            speaker: 'TogeeVision',
            register: 'Fixed Point',
            line: "Samedi soir, 24 octobre 2026, dans le salon à l'étage de Pianos au 158, rue Ludlow. Sous les néons cramoisis du plafond et une boule à facettes projetant des éclats émeraude et rubis sur le plancher de bois, Honeychild Coleman s'avance au micro avec sa formation dub-shoegaze et blues-punk HoneyChild's DEM, accompagnée par Monk Americana à la guitare et aux machines et le batteur Jason « Biz » Lucas (The 1865) sur la batterie Sonor pour la deuxième soirée du festival « I Have A Dream Pop ».",
          },
          {
            speaker: 'Lex Gupta',
            register: 'Structural Read',
            line: "Fixée directement sur le plancher de la scène de Pianos à côté du pédalier, la feuille de route imprimée du 24 octobre déploie une architecture en sept morceaux conçue comme un flux sonore continu : « Echelon » (sur la boucle « It's Understood ») plonge dans « Drug Bags & Leaves » (Starts with Biz), dont la traînée bruitiste se fond dans « December » puis « Takeover », avant « Heelspur Whisper », « Circumstances » et le final « The Salt ».",
          },
          {
            speaker: 'Anansi Byte',
            register: 'Provenance Read',
            line: "Monk Americana, Biz et Honeychild Coleman portent une profonde lignée souterraine new-yorkaise — de leur rencontre au début des années 90 dans la navette de la 42e Rue jusqu'à The 1865 (explorant les parallèles entre les enjeux systémiques modernes et la vie post-Émancipation à l'ombre de la Confédération déchue sur l'album « Don't Tread On We! » chez Mass Appeal Records et le simple « Blitzkrieg Cops » en 2024, avec Flora Lucini, Chuck Treece et le regretté cofondateur Sacha Jenkins, ainsi que le duo « Honeychild & Biz » chez Sleepwalk, Pianos et P.I.T.). Pour le septième et dernier morceau, « The Salt », ils accueillent l'invitée spéciale Jennie Oliver-Cretara à l'alto, dont l'archet traverse les guitares électriques, la basse et la batterie Sonor de Biz dans un crescendo dub-shoegaze de quatre minutes trente-deux secondes.",
          },
          {
            speaker: 'Kaelen Vance',
            register: 'Blueprint Read',
            line: "Télémétrie acoustique enregistrée en 44.1 kHz stéréo à -14.0 LUFS, entrelacée avec la captation vidéo 4K sur scène et deux enregistrements Pixel Recorder réalisés dans le salon à l'étage de Pianos NYC.",
          },
        ],
        closing:
          "De la navette de la 42e Rue au début des années 90, de The 1865 (« Don't Tread On We! ») et des salons de thé de Brooklyn en Hi-8 jusqu'au salon à l'étage de Pianos au 158, rue Ludlow : gardez la boucle active, honorez la lignée et laissez résonner « The Salt ».",
        mediaArchaeology: {
          description:
            "Documente la performance du samedi 24 octobre 2026 de Honeychild Coleman avec HoneyChild's DEM, accompagnée par Monk Americana, Biz et l'altiste invitée Jennie Oliver-Cretara dans le salon à l'étage de Pianos NYC (158, rue Ludlow) lors du festival « I Have A Dream Pop ».",
          highlight:
            "Salon à l'étage de Pianos NYC (24/10/26) : HoneyChild's DEM avec Monk Americana, Biz et Jennie Oliver-Cretara (alto) — concert continu de 7 titres (« Echelon » jusqu'à « The Salt »).",
        },
      },
    },
    currentTransmission:
      "Honeychild Coleman commands the Pianos NYC Upstairs Lounge (158 Ludlow Street) on Saturday, October 24, 2026 as HoneyChild's DEM accompanied by Monk Americana and Biz for the 'I Have A Dream Pop Festival,' performing a seven-song continuous set ('Echelon,' 'Drug Bags & Leaves,' 'December,' 'Takeover,' 'Heelspur Whisper,' 'Circumstances,' and 'The Salt' featuring Jennie Oliver-Cretara on viola).",
    currentNote: "Live field transmission from Pianos NYC Upstairs Lounge (158 Ludlow St, Oct 24, 2026): HoneyChild's DEM w/ Monk Americana, Biz & Jennie Oliver-Cretara (viola).",
    fieldEchoes: [
      "Pianos NYC Upstairs Lounge (158 Ludlow St, 10/24/26): 7-song continuous set with Monk Americana & Biz ('Echelon,' 'Drug Bags & Leaves,' 'December,' 'Takeover,' 'Heelspur Whisper,' 'Circumstances,' and 'The Salt' w/ Jennie Oliver-Cretara on viola).",
      "The 1865 & 'Honeychild & Biz': Exploring post-Emancipation life and modern systemic parallels alongside drummer Jason 'Biz' Lucas, Monk Americana, Flora Lucini, Chuck Treece, and late co-founder Sacha Jenkins ('Don't Tread On We!' on Mass Appeal Records; 'Blitzkrieg Cops').",
      'The Tea Shop Model: proven efficiency in one-to-one creative capture.',
      'The aspirational lesson: direct, intuitive cinematography preserves the Entity better than large-scale club setups.',
      'PunkCon 2026 Counter-Curricula: pedagogical sabotage through physical print and subcultural sound.',
    ],
    integration: {
      title: 'Integration Strategy',
      body:
        "Links Honeychild Coleman's Saturday, October 24, 2026 Pianos NYC field transmission ('HoneyChild's DEM' w/ Monk Americana, Biz & Jennie Oliver-Cretara), setlist artifact, and PunkCon 2026 counter-curricula directly to the NYC Signal Radar.",
    },
    community: {
      matrix: {
        enabled: true,
        guestAccess: true,
        roomAlias: '#honeychild-coleman:togeevision.com',
        joinUrl: 'https://matrix.to/#/#honeychild-coleman:togeevision.com',
        label: 'Join Honeychild’s Signal Channel',
        requiresTogeeVisionLogin: false,
      },
    },
    archiveItems: [
      {
        id: 'honeychild-pianos-field-transmission-2026-10-24',
        title: "Pianos NYC Field Transmission — HoneyChild's DEM w/ Monk Americana, Biz & Jennie Oliver-Cretara (10/24/26)",
        date: 'October 24, 2026 · Pianos NYC',
        duration: '03:46 Field Chronicle',
        visibility: 'public',
        type: 'audio',
        url: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/audio/transmission_artist-honeychild-coleman.mp3',
        accessUrl: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/audio/transmission_artist-honeychild-coleman.mp3',
        notes: "Saturday night field chronicle from Pianos Upstairs Lounge (158 Ludlow St) for the 'I Have A Dream Pop Festival,' documenting the 7-song continuous set with Monk Americana and Biz ('Echelon' through 'The Salt' w/ Jennie Oliver-Cretara on viola).",
      },
      {
        id: 'honeychild-pianos-dem-video-clip-1-2026-10-24',
        title: "HoneyChild's DEM w/ Monk Americana & Biz — Live at Pianos NYC Upstairs Lounge (Saturday Night Clip I)",
        date: 'October 24, 2026 · Pianos NYC',
        duration: 'Live Stage Video',
        visibility: 'public',
        type: 'video',
        url: 'https://docs.google.com/videos/d/1qHQEHzuGGaaraJjhmIyjaZRXo0hxPN8xpSgkl3_zEOI/play?usp=sharing',
        accessUrl: 'https://docs.google.com/videos/d/1qHQEHzuGGaaraJjhmIyjaZRXo0hxPN8xpSgkl3_zEOI/play?usp=sharing',
        image: '/images/transmissions/nyc/pianos-honeychild-dem-monk-stage-red.jpg',
        thumbnail: '/images/transmissions/nyc/pianos-honeychild-dem-monk-stage-red.jpg',
        caption: "Saturday night stage video capture (IMG_3207) of Honeychild Coleman (HoneyChild's DEM), Monk Americana, and Biz performing at Pianos NYC Upstairs Lounge (158 Ludlow Street) during the 'I Have A Dream Pop Festival.'",
        notes: "Saturday night stage video capture (IMG_3207) of Honeychild Coleman (HoneyChild's DEM), Monk Americana, and Biz performing at Pianos NYC Upstairs Lounge (158 Ludlow Street) during the 'I Have A Dream Pop Festival.'",
      },
      {
        id: 'honeychild-pianos-dem-video-clip-2-2026-10-24',
        title: "HoneyChild's DEM w/ Monk Americana, Biz & Jennie Oliver-Cretara — 'The Salt' Live at Pianos NYC (Saturday Night Clip II)",
        date: 'October 24, 2026 · Pianos NYC',
        duration: '4K Live Stage Video',
        visibility: 'public',
        type: 'video',
        url: 'https://docs.google.com/videos/d/1DxnuNZmyvx6XaJJEPIGwuq_Q4UY5-RKzt6WBxmgMyvA/play?usp=sharing',
        accessUrl: 'https://docs.google.com/videos/d/1DxnuNZmyvx6XaJJEPIGwuq_Q4UY5-RKzt6WBxmgMyvA/play?usp=sharing',
        image: '/images/transmissions/nyc/pianos-honeychild-dem-the-salt-viola.jpg',
        thumbnail: '/images/transmissions/nyc/pianos-honeychild-dem-the-salt-viola.jpg',
        caption: "Saturday night 4K stage video capture (PXL_20261025_003408137) of HoneyChild's DEM with Monk Americana, Biz, and special guest Jennie Oliver-Cretara on viola performing 'The Salt' at Pianos NYC Upstairs Lounge.",
        notes: "Saturday night 4K stage video capture (PXL_20261025_003408137) of HoneyChild's DEM with Monk Americana, Biz, and special guest Jennie Oliver-Cretara on viola performing 'The Salt' at Pianos NYC Upstairs Lounge.",
      },
      {
        id: 'honeychild-pianos-dem-video-clip-3-2026-10-24',
        title: "HoneyChild's DEM w/ Monk Americana & Biz — Live at Pianos NYC Upstairs Lounge (Saturday Night Clip III)",
        date: 'October 24, 2026 · Pianos NYC',
        duration: 'Live Stage Video',
        visibility: 'public',
        type: 'video',
        url: 'https://docs.google.com/videos/d/1CYlQdBHyrkXJM_UVtJpzTLSPyVUCbCotMknqgZW8aFQ/play?usp=sharing',
        accessUrl: 'https://docs.google.com/videos/d/1CYlQdBHyrkXJM_UVtJpzTLSPyVUCbCotMknqgZW8aFQ/play?usp=sharing',
        image: '/images/transmissions/nyc/pianos-honeychild-dem-monk-disco-ball.jpg',
        thumbnail: '/images/transmissions/nyc/pianos-honeychild-dem-monk-disco-ball.jpg',
        caption: "Saturday night stage video capture (IMG_3208) of Honeychild Coleman (HoneyChild's DEM), Monk Americana, and Biz under crimson neon and mirror-ball light at Pianos NYC (158 Ludlow Street).",
        notes: "Saturday night stage video capture (IMG_3208) of Honeychild Coleman (HoneyChild's DEM), Monk Americana, and Biz under crimson neon and mirror-ball light at Pianos NYC (158 Ludlow Street).",
      },
      {
        id: 'honeychild-pianos-dem-video-clip-4-2026-10-24',
        title: "HoneyChild's DEM w/ Monk Americana & Biz — Live at Pianos NYC Upstairs Lounge (Saturday Night Clip IV)",
        date: 'October 24, 2026 · Pianos NYC',
        duration: 'Live Stage Video',
        visibility: 'public',
        type: 'video',
        url: 'https://docs.google.com/videos/d/13VF0mI1ljMCaahOQ9XnE4KgscByzYxdPAi0pFqwI9Ok/play?usp=sharing',
        accessUrl: 'https://docs.google.com/videos/d/13VF0mI1ljMCaahOQ9XnE4KgscByzYxdPAi0pFqwI9Ok/play?usp=sharing',
        image: '/images/transmissions/nyc/pianos-honeychild-dem-quartet-wide.jpg',
        thumbnail: '/images/transmissions/nyc/pianos-honeychild-dem-quartet-wide.jpg',
        caption: "Saturday night stage video capture (IMG_3209) of HoneyChild's DEM, Monk Americana, and Biz locked into a continuous dub-shoegaze groove at Pianos NYC Upstairs Lounge.",
        notes: "Saturday night stage video capture (IMG_3209) of HoneyChild's DEM, Monk Americana, and Biz locked into a continuous dub-shoegaze groove at Pianos NYC Upstairs Lounge.",
      },
      {
        id: 'honeychild-pianos-green-room-2026-10-24',
        title: 'Pianos NYC Green Room — Monk Americana, Honeychild Coleman, Jennie Olivera-Cretara & Biz (10/24/26)',
        date: 'October 24, 2026 · Pianos NYC',
        duration: 'Green Room Portrait',
        visibility: 'public',
        type: 'image',
        url: '/images/transmissions/nyc/pianos-honeychild-dem-monk-green-room.jpg',
        accessUrl: '/images/transmissions/nyc/pianos-honeychild-dem-monk-green-room.jpg',
        image: '/images/transmissions/nyc/pianos-honeychild-dem-monk-green-room.jpg',
        thumbnail: '/images/transmissions/nyc/pianos-honeychild-dem-monk-green-room.jpg',
        caption: "Backstage portrait inside the Pianos NYC Green Room (158 Ludlow Street, Lower East Side) during the 'I Have A Dream Pop Festival' (left to right): Monk Americana, Honeychild Coleman, Jennie Olivera-Cretara, and drummer Jason “Biz” Lucas (The 1865).",
        notes: "Backstage portrait inside the Pianos NYC Green Room (158 Ludlow Street, Lower East Side) during the 'I Have A Dream Pop Festival' (left to right): Monk Americana, Honeychild Coleman, Jennie Olivera-Cretara, and drummer Jason “Biz” Lucas (The 1865).",
      },
      {
        id: 'honeychild-pianos-stage-red-2026-10-24',
        title: "HoneyChild's DEM, Monk Americana & Biz Live at Pianos Upstairs Lounge (10/24/26)",
        date: 'October 24, 2026 · Pianos NYC',
        duration: 'Live Stage Photograph',
        visibility: 'public',
        type: 'image',
        url: '/images/transmissions/nyc/pianos-honeychild-dem-monk-stage-red.jpg',
        accessUrl: '/images/transmissions/nyc/pianos-honeychild-dem-monk-stage-red.jpg',
        image: '/images/transmissions/nyc/pianos-honeychild-dem-monk-stage-red.jpg',
        thumbnail: '/images/transmissions/nyc/pianos-honeychild-dem-monk-stage-red.jpg',
        caption: "Live stage capture at Pianos Upstairs Lounge (left to right): Monk Americana on Stratocaster and tabletop sampler in front of his Vox amplifier, Honeychild Coleman at center mic, and Biz on the Sonor drum kit.",
        notes: "Live stage capture at Pianos Upstairs Lounge (left to right): Monk Americana on Stratocaster and tabletop sampler in front of his Vox amplifier, Honeychild Coleman at center mic, and Biz on the Sonor drum kit.",
      },
      {
        id: 'honeychild-pianos-setlist-2026-10-24',
        title: "HONEYCHILD COLEMAN's DEM — Pianos Stage Setlist (10/24/26)",
        date: 'October 24, 2026 · Pianos NYC',
        duration: 'Stage Artifact',
        visibility: 'public',
        type: 'image',
        url: '/images/transmissions/nyc/pianos-honeychild-dem-setlist-2026-10-24.jpg',
        accessUrl: '/images/transmissions/nyc/pianos-honeychild-dem-setlist-2026-10-24.jpg',
        image: '/images/transmissions/nyc/pianos-honeychild-dem-setlist-2026-10-24.jpg',
        thumbnail: '/images/transmissions/nyc/pianos-honeychild-dem-setlist-2026-10-24.jpg',
        notes: "Printed 7-song setlist on the Pianos floorboards: 1. Echelon (Loop 'It's Understood'), 2. Drug Bags & Leaves (Starts with Biz), 3. December, 4. Takeover, 5. Heelspur Whisper, 6. Circumstances, 7. The Salt (Special guest on viola Jennie Oliver-Cretara).",
      },
      {
        id: 'honeychild-pianos-dream-pop-poster-2026-10-24',
        title: "I Have A Dream Pop Festival (Sat. 10/24/26 NYC) Official Poster — Pianos NYC",
        date: 'October 24, 2026 · Pianos NYC',
        duration: 'Festival Poster',
        visibility: 'public',
        type: 'image',
        url: '/images/transmissions/nyc/pianos-i-have-a-dream-pop-festival-poster-2026-10-24.png',
        accessUrl: '/images/transmissions/nyc/pianos-i-have-a-dream-pop-festival-poster-2026-10-24.png',
        image: '/images/transmissions/nyc/pianos-i-have-a-dream-pop-festival-poster-2026-10-24.png',
        thumbnail: '/images/transmissions/nyc/pianos-i-have-a-dream-pop-festival-poster-2026-10-24.png',
        notes: "Official Saturday 10/24/26 NYC poster for the 'I Have A Dream Pop Festival' at Pianos (158 Ludlow St., L.E.S.) featuring The Veldt, Burnt Sugar (NYC), Honeychild Coleman's DEM (NYC), Spirit Hotel, Mahogany, Faith, and more.",
      },
      {
        id: 'honeychild-pianos-the-salt-viola-2026-10-24',
        title: "'The Salt' Finale w/ Special Guest Jennie Oliver-Cretara on Viola & Biz on Drums",
        date: 'October 24, 2026 · Pianos NYC',
        duration: '4K Stage Still',
        visibility: 'public',
        type: 'image',
        url: '/images/transmissions/nyc/pianos-honeychild-dem-the-salt-viola.jpg',
        accessUrl: '/images/transmissions/nyc/pianos-honeychild-dem-the-salt-viola.jpg',
        image: '/images/transmissions/nyc/pianos-honeychild-dem-the-salt-viola.jpg',
        thumbnail: '/images/transmissions/nyc/pianos-honeychild-dem-the-salt-viola.jpg',
        notes: "4K video frame from 'The Salt' at Pianos Upstairs Lounge showing Jennie Oliver-Cretara bowing viola alongside Honeychild Coleman, Monk Americana, and Biz on the Sonor drum kit.",
      },
      {
        id: 'honeychild-pianos-dream-pop-festival-2026-10-24',
        title: "Pianos NYC (158 Ludlow St) — 'I Have A Dream Pop Festival' Marquee",
        date: 'October 24, 2026 · Pianos NYC',
        duration: 'Festival Node',
        visibility: 'public',
        type: 'image',
        url: '/images/transmissions/nyc/pianos-ludlow-marquee-dream-pop.jpg',
        accessUrl: '/images/transmissions/nyc/pianos-ludlow-marquee-dream-pop.jpg',
        image: '/images/transmissions/nyc/pianos-ludlow-marquee-dream-pop.jpg',
        thumbnail: '/images/transmissions/nyc/pianos-ludlow-marquee-dream-pop.jpg',
        notes: "Saturday night showcase at Pianos (158 Ludlow Street, Lower East Side) as HoneyChild's DEM accompanied by Monk Americana and Biz for the 'I Have A Dream Pop Festival' founded by Daniel and Danny Chavis of The Veldt.",
      },
      {
        id: 'honeychild-the-1865-dont-tread-on-we',
        title: "The 1865 — 'Don't Tread On We!' (Mass Appeal Records / Bandcamp)",
        date: 'Mass Appeal Records · LP & Archive',
        duration: 'Full-Length LP & Lineage Dossier',
        visibility: 'public',
        type: 'link',
        url: 'https://the1865.bandcamp.com/album/dont-tread-on-we',
        accessUrl: 'https://the1865.bandcamp.com/album/dont-tread-on-we',
        dossierUrl: 'https://the1865.bandcamp.com/album/dont-tread-on-we',
        notes: "Breakout debut LP 'Don't Tread On We!' released via Mass Appeal Records by The 1865—featuring lead vocalist/baritone guitarist Honeychild Coleman and drummer Jason 'Biz' Lucas, with lineage including Monk Americana, bassist Flora Lucini, session legend Chuck Treece, and late co-founder Sacha Jenkins, alongside their 2024 single 'Blitzkrieg Cops' and live 'Honeychild & Biz' duo sets across Sleepwalk, Pianos, and P.I.T.",
      },
      {
        id: 'honeychild-gracefully-2008',
        title: 'Gracefully — Halo Inside (Come la Luna) | Matteite Records',
        date: '2008 Digital Hi-8 Capture',
        duration: 'Video Archive',
        visibility: 'public',
        type: 'video',
        url: 'https://youtu.be/zbu5E_aUw90',
        accessUrl: 'https://youtu.be/zbu5E_aUw90',
        notes: 'Captured on Digital Hi-8 in a Brooklyn tea shop. The blueprint for Minimalist Kismet.',
      },
      {
        id: 'honeychild-orange-2009',
        title: 'Orange — Delano Franklin Visual Remix (Halo Inside)',
        date: '2009 Visual Archive',
        duration: 'Video Archive',
        visibility: 'public',
        type: 'video',
        url: 'https://youtu.be/nCyHWeRWnwk',
        accessUrl: 'https://youtu.be/nCyHWeRWnwk',
        notes: 'Remixed visual signal with MilkDrop plugin visuals from Halo Inside (Come la Luna), Matteite Records 2008.',
      },
      {
        id: 'honeychild-field-transmission-2026',
        title: 'PunkCon 2026 & Sista Grrrl Field Transmission — Honeychild Coleman',
        date: 'May 14, 2026',
        duration: 'Field Chronicle',
        visibility: 'public',
        type: 'audio',
        url: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/chronicles/2026/audio/2026-05-14_morning_transmission_artist-honeychild-coleman.mp3',
        accessUrl: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/chronicles/2026/audio/2026-05-14_morning_transmission_artist-honeychild-coleman.mp3',
        notes: 'Broadcast chronicle mapping Sista Grrrl origins, East Village punk corridors, and the PunkCon 2026 Las Vegas symposium.',
      },
      {
        id: 'honeychild-punkcon-2026-spotify-playlist',
        title: 'PunkCon 2026 Companion Playlist — Curated by DJ Sugarfree BK',
        date: 'May 2026 · PunkCon Official Companion',
        duration: '60 Songs · 2 hr 30 min',
        visibility: 'public',
        type: 'link',
        url: 'https://open.spotify.com/playlist/5hFaVHB5LtWRBasLVHbLep',
        accessUrl: 'https://open.spotify.com/playlist/5hFaVHB5LtWRBasLVHbLep',
        image: '/images/honeychild-coleman/honeychild-coleman-punkcon-2026-spotify-playlist.jpg',
        thumbnail: '/images/honeychild-coleman/honeychild-coleman-punkcon-2026-spotify-playlist.jpg',
        dossierUrl: 'https://open.spotify.com/playlist/5hFaVHB5LtWRBasLVHbLep',
        notes: 'Official 60-track companion playlist curated by DJ Sugarfree BK (Honeychild Coleman) for Panel 3: "From \'Zines to Reels: Collage and Design As Way of Life Expression" at PunkCon 2026. Featuring Alice Bag ("No Gifts For Nazis"), Tamar-Kali ("Boot"), and Bite The Hand That Feeds.',
      },
      {
        id: 'honeychild-punkcon-2026-zine-workshop',
        title: 'Zine Workshop: From \'Zines to Reels — Collage and Design As Way of Life Expression',
        date: 'May 8, 2026 · PunkCon Las Vegas',
        duration: 'Workshop Artifacts',
        visibility: 'public',
        type: 'image',
        url: '/images/honeychild-coleman/honeychild-coleman-punkcon-2026-zine-workshop-table.jpg',
        accessUrl: '/images/honeychild-coleman/honeychild-coleman-punkcon-2026-zine-workshop-table.jpg',
        image: '/images/honeychild-coleman/honeychild-coleman-punkcon-2026-zine-workshop-table.jpg',
        thumbnail: '/images/honeychild-coleman/honeychild-coleman-punkcon-2026-zine-workshop-table.jpg',
        notes: 'Physical artifact documentation: "This Hotel Life", "Music is the Weapon Vol. 1", stencil plates, and workshop flyer for PunkCon 2026: Teaching for the Masses.',
      },
      {
        id: 'honeychild-punkcon-2026-unlv-panel',
        title: 'PunkCon 2026: Teaching for the Masses — Punk Pedagogies for Scholastic Saboteurs',
        date: 'May 7–8, 2026 · UNLV',
        duration: 'Symposium Panel',
        visibility: 'public',
        type: 'image',
        url: '/images/honeychild-coleman/honeychild-coleman-punkcon-2026-unlv-panel.jpg',
        accessUrl: '/images/honeychild-coleman/honeychild-coleman-punkcon-2026-unlv-panel.jpg',
        image: '/images/honeychild-coleman/honeychild-coleman-punkcon-2026-unlv-panel.jpg',
        thumbnail: '/images/honeychild-coleman/honeychild-coleman-punkcon-2026-unlv-panel.jpg',
        notes: 'Symposium at University of Nevada, Las Vegas (UNLV) exploring grassroots punk pedagogies, DIY scholastic sabotage, and zine distribution circuits.',
      },
      {
        id: 'honeychild-punkcon-2026-crew-outdoor',
        title: 'PunkCon 2026 Assembly & Field Crew — Las Vegas',
        date: 'May 2026 · Las Vegas',
        duration: 'Field Photograph',
        visibility: 'public',
        type: 'image',
        url: '/images/honeychild-coleman/honeychild-coleman-punkcon-2026-crew-outdoor.jpg',
        accessUrl: '/images/honeychild-coleman/honeychild-coleman-punkcon-2026-crew-outdoor.jpg',
        image: '/images/honeychild-coleman/honeychild-coleman-punkcon-2026-crew-outdoor.jpg',
        thumbnail: '/images/honeychild-coleman/honeychild-coleman-punkcon-2026-crew-outdoor.jpg',
        notes: 'Honeychild Coleman with fellow Black punk, alt-culture, and Sista Grrrl delegates gathering at PunkCon 2026 in Las Vegas.',
      },
      {
        id: 'honeychild-lounge-trio-session',
        title: 'Minimalist Kismet Session — Honeychild Coleman & Collaborators',
        date: 'NYC Field Capture',
        duration: 'Archival Photograph',
        visibility: 'public',
        type: 'image',
        url: '/images/honeychild-coleman/honeychild-coleman-lounge-trio.jpg',
        accessUrl: '/images/honeychild-coleman/honeychild-coleman-lounge-trio.jpg',
        image: '/images/honeychild-coleman/honeychild-coleman-lounge-trio.jpg',
        thumbnail: '/images/honeychild-coleman/honeychild-coleman-lounge-trio.jpg',
        notes: 'Intimate field capture embodying the Minimalist Kismet methodology: direct human presence, quirky low-fi atmosphere, no commercial club pretense.',
      },
    ],
    upcomingNodes: [
      {
        date: 'October 24, 2026',
        isoDate: '2026-10-24T20:30:00-04:00',
        venue: "Pianos NYC (158 Ludlow St) — 'I Have A Dream Pop Festival'",
        city: 'Lower East Side, New York, NY',
        time: 'Saturday · 8:30 PM',
        title: "I Have A Dream Pop Festival — Honeychild Coleman (HoneyChild's DEM) accompanied by Monk Americana",
        notes: "Live Lower East Side set at Pianos (158 Ludlow St) as HoneyChild's DEM accompanied by Monk Americana, alongside The Veldt and Burnt Sugar The Arkestra Chamber.",
        eventId: 'demo-event-nyc-pianos-honeychild-monk-2026',
        venueId: 'venue-pianos-nyc',
        posterUrl: '/images/transmissions/nyc/pianos-ludlow-marquee-dream-pop.jpg',
      },
      {
        date: 'July 22, 2026',
        isoDate: '2026-07-22T19:30:00-04:00',
        venue: 'Melophobe BK — Sista Grrrl & Riot Grrrl Panel & Zine Making',
        city: 'Brooklyn, NY',
        time: '7:30 PM',
        title: 'Sista Grrrl & Riot Grrrl Panel with Honeychild Coleman',
        eventId: 'demo-event-nyc-sistagrrrl-panel-2026',
      },
    ],
  },
  'gottfried-stoger': {
    id: 'gottfried-stoger',
    profileNumber: '003',
    name: 'Gottfried Stöger',
    role: 'Woodwinds / Composition / Global Improvisation',
    city: 'nyc',
    status: 'Active Resident Hub - Kismat, NYC',
    transmission: 'Kismat Resident Signal',
    transmissionChronicleAudioUrl: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/chronicles/2026/audio/2026-05-25_evening_transmission_artist-gottfried-stoger.mp3',
    transmissionType: 'Active Resident Hub',
    landingPath: '/nyc',
    landingLabel: 'NYC Page',
    radarPath: '/passport/radar?city=nyc',
    associatedVenueIds: ['kismat-washington-heights'],
    image: '/images/gottfried-stoger-washington-heights-2026.jpg',
    imageAlt: 'Gottfried Stöger and ensemble live outdoor performance, Washington Heights, District 71 (2026)',
    imageCaption: 'Washington Heights District 71 outdoor live session (June 2026) — Gottfried Stöger on sax with acoustic bass under the "ART NOT WAR" canopy.',
    imagePosition: 'center 30%',
    tags: ['Woodwinds', 'Composition', 'Global Improvisation', 'Broadway', 'Kismat Resident', 'Dreamhunter', 'ACFNY'],
    relatedTransmissions: [
      {
        id: 'venue-kismat-washington-heights',
        eyebrow: '603 Fort Washington Ave · Washington Heights, NYC',
        title: 'Kismat Washington Heights: Uptown Crossroads, Live Jazz & Karaoke Field Transmission',
        description: 'Explore the Kismat Washington Heights room chronicle where Gottfried Stöger anchors Tuesday Jazz Night and Friday live music alongside Uptown Manhattan collaborators.',
        path: '/passport/transmissions/venue-kismat-washington-heights',
        ctaLabel: 'Open Kismat Washington Heights Transmission →',
      },
      {
        id: 'kismat-room-calendar',
        eyebrow: 'Evergreen Venue Node · NYC-01',
        title: 'Kismat Washington Heights: Live Jazz & Karaoke Room Calendar',
        description: 'View the weekly Kismat schedule for Tuesday Jazz Night with Gottfried Stöger, Friday live sets, and Uptown community sessions.',
        path: '/kismat',
        ctaLabel: 'Open Kismat Room & Schedule →',
      },
    ],
    origin: {
      title: 'The Mastery & World Vision',
      subtitle: 'Acoustic Provenance',
      body:
        'Gottfried Stöger represents a rare Triple Signal in the New York landscape: the precision of the Austrian Classical tradition (originating in Salzburg), the fluidity and rhythmic depth of American Jazz (Manhattan School of Music & University of Miami), and the uncompromising discipline of Broadway premier woodwind chairs. Through his seminal ensemble DREAMHUNTER, Stöger takes on the challenge of creating a new world music by seamlessly interweaving Jazz, European Classical and Romantic traditions, and global folk music traditions forged through creative collaborations across India, Brazil, Indonesia, and Eastern Europe.',
      note:
        'The signal is technical, global, and acoustic: woodwind command with a multi-decade career held in one focused profile.',
    },
    summary:
      'Gottfried Stöger anchors the Kismat Signal Radar as a resident performer whose woodwind fluency, composition practice, and global improvisational reach (including his acclaimed DREAMHUNTER project with the Austrian Cultural Forum New York) make him a benchmark artist for the Gig Passport profile system.',
    frequency: [
      {
        label: 'Triple Signal',
        value:
          'Austrian Classical precision, American Jazz fluency, and Broadway woodwind discipline operating as one performance language.',
      },
      {
        label: 'DREAMHUNTER Concept',
        value:
          'Blending Jazz, European Classical and Romantic music, and global folk traditions into a singular acoustic world vision.',
      },
      {
        label: 'Global Collaboration',
        value:
          'A bridge between West and East, with collaborations connected to Pawan Kumar, Toninho Horta, and the late Joe Zawinul.',
      },
      {
        label: 'Single-Source Signal',
        value:
          'A platform-independent artist home: no algorithm clutter, no sponsored feed pressure, and no requirement to maintain social performance as a second career.',
      },
      {
        label: 'Physical-to-Digital Handshake',
        value:
          'Localized QR deployment at Kismat can move audiences directly from the room to archives, recordings, and schedule context in one scan.',
      },
    ],
    lineage: [
      'Austrian roots & academic lineage: musical training in Salzburg, Austria; Master of Music from the University of Miami; Manhattan School of Music jazz studies; former Director of the International Jazz Seminar in Salzburg.',
      'DREAMHUNTER founder: creator and composer of the international ensemble featuring Walter Fischbacher (keys), Marcos Varela (acoustic bass), Peter Kronreif (drums), with guest artists Elisabeth Lohninger and Franz Hackl.',
      'Broadway pedigree: veteran woodwind chair for Cats, Les Misérables, 42nd Street, and A Chorus Line.',
      'Jazz masters registry: Kenny Barron, Marc Copland, David Liebman, Maria Schneider, and Toots Thielemans.',
      'World folk collaborations: creative partnerships with folk and classical masters across India (Pawan Kumar), Brazil (Toninho Horta), Indonesia, and Eastern Europe.',
      'Instrument registry: all saxophones, flute/piccolo, clarinet, and bass clarinet.',
    ],
    currentTransmission:
      'Gottfried Stöger anchors Tuesday Jazz Night and frequent Friday live sets at Kismat in Washington Heights (603 Fort Washington Ave), turning the neighborhood room into a weekly woodwind and improvisation hub, alongside community outdoor sessions throughout District 71.',
    currentNote: 'Tuesday Jazz Night & Friday Live Music at Kismat, Washington Heights.',
    fieldEchoes: [
      'The Gig Passport solution preserves the depth of a multi-decade career without reducing the artist to social algorithm fragments.',
      'In-house QR Cards produced through Epson ET-15000 precision link directly from Kismat to this profile.',
      'Austrian Cultural Forum New York (ACFNY) Make Music New York concert documentation and live outdoor field captures preserved permanently on the sovereign cultural ledger.',
    ],
    archiveItems: [
      {
        id: 'gottfried-washington-heights-video-2026',
        title: 'Washington Heights Solstice Session — Gottfried Stöger Live (District 71)',
        date: 'June 23, 2026',
        duration: 'Live Video Capture',
        visibility: 'public',
        type: 'video',
        thumbnailUrl: '/images/gottfried-stoger-washington-heights-2026.jpg',
        url: 'https://drive.google.com/file/d/1NHJIVLVhr1gWtfS_BftZI408npEhJx6_/view?usp=drive_link',
        accessUrl: 'https://drive.google.com/file/d/1NHJIVLVhr1gWtfS_BftZI408npEhJx6_/view?usp=drive_link',
      },
      {
        id: 'gottfried-dreamhunter-mmny-2021',
        title: "Make Music NY 2021: Gottfried Stöger's DREAMHUNTER (ACFNY)",
        date: 'June 21, 2021',
        duration: 'Concert Video & ACFNY Dossier',
        visibility: 'public',
        type: 'video',
        thumbnailUrl: 'https://i.ytimg.com/vi/Jdv4rzUCp3E/hqdefault.jpg',
        url: 'https://youtu.be/Jdv4rzUCp3E?si=fQoh-AuImxbT_HcG',
        accessUrl: 'https://youtu.be/Jdv4rzUCp3E?si=fQoh-AuImxbT_HcG',
        dossierUrl: 'https://acfny.org/event/make-music-ny-2021-gottfried-stogers-dreamhunter/',
      },
      {
        id: 'gottfried-kismat-resident-chronicle',
        title: 'Kismat Resident Signal — Gottfried Stöger Field Transmission',
        date: 'May 25, 2026 · Kismat Washington Heights',
        duration: 'Field Chronicle',
        visibility: 'public',
        type: 'audio',
        url: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/chronicles/2026/audio/2026-05-25_evening_transmission_artist-gottfried-stoger.mp3',
        accessUrl: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/chronicles/2026/audio/2026-05-25_evening_transmission_artist-gottfried-stoger.mp3',
        transmissionPath: '/passport/transmissions/artist-gottfried-stoger',
        transmissionLabel: 'Open Gottfried Stöger Transmission →',
        caption: 'Gottfried Stöger resident woodwinds, Broadway discipline, and DREAMHUNTER field chronicle anchored at Kismat in Washington Heights.',
      },
      {
        id: 'gottfried-kismat-venue-transmission',
        title: 'Kismat Washington Heights — Uptown Room & Live Jazz Field Transmission',
        date: '603 Fort Washington Ave · Washington Heights, NYC',
        duration: 'Venue Field Chronicle',
        visibility: 'public',
        type: 'audio',
        url: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/chronicles/2026/audio/2026-05-15_midnight_transmission_venue-kismat-washington-heights.mp3',
        accessUrl: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/chronicles/2026/audio/2026-05-15_midnight_transmission_venue-kismat-washington-heights.mp3',
        transmissionPath: '/passport/transmissions/venue-kismat-washington-heights',
        transmissionLabel: 'Open Kismat Washington Heights Transmission →',
        caption: 'Room transmission from Kismat Washington Heights (603 Fort Washington Ave), home to Gottfried Stöger’s Tuesday Jazz Night residency and Friday live music.',
      },
    ],
    upcomingNodes: [
      {
        date: 'TUESDAYS · WEEKLY',
        venue: 'Tuesday Jazz Night at Kismat',
        city: '603 Fort Washington Ave, Washington Heights, NYC',
        time: '8:00 PM – 11:00 PM',
        eventId: 'kismat-tuesday-jazz-night',
        notes: 'Weekly Tuesday Jazz Night residency at Kismat with Gottfried Stöger & Uptown Ensemble',
      },
      {
        date: 'FRIDAYS · WEEKLY',
        venue: 'Kismat Weekly Friday Live Music Schedule',
        city: '603 Fort Washington Ave, Washington Heights, NYC',
        time: '8:30 PM – 11:30 PM',
        eventId: 'kismat-uptown-friday-2026',
        notes: 'Frequent Friday night live sets at Kismat Washington Heights',
      },
    ],
    integration: {
      title: 'Integration Strategy',
      body:
        'This profile positions Gottfried Stöger as the technical benchmark for Kismat resident artists: a high-fidelity Entity Archive built for venue QR deployment, audience discovery, and live room routing.',
    },
  },
  'ed-marshall': {
    id: 'ed-marshall',
    profileNumber: '004',
    name: 'Ed Marshall',
    role: 'Photographer, Videographer, and Multimedia Producer',
    city: 'nyc',
    status: 'Active Resident Hub - Kismat, NYC',
    transmission: 'Kismat Resident Signal',
    transmissionChronicleAudioUrl: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/chronicles/2026/audio/2026-06-06_noon_transmission_artist-ed-marshall.mp3',
    transmissionType: 'Active Resident Hub',
    landingPath: '/nyc',
    landingLabel: 'NYC Page',
    radarPath: '/passport/radar?city=nyc',
    associatedVenueIds: ['kismat-washington-heights'],
    tags: ['Photography', 'Videography', 'Multimedia', 'Street Photojournalism', 'Electronic Music', 'NYC'],
    origin: {
      title: 'The Visual & Sonic Provenance',
      subtitle: 'Street-Level Witness, Bronx/NYC',
      body:
        'Ed Marshall leads Ed Marshall Productions NYC, capturing portraits, live music, and events using a non-intrusive "fly on the wall" photojournalistic approach. Favoring natural and existing light, his work spans photography, filmmaking, and a deep history in the 1990s underground electronic music scene under the monikers Dreamscape and Aplomb.',
      note:
        'The frequency is grounded in visual and musical preservation: capturing true-to-life portraits and preserving rare underground house archives.',
    },
    summary:
      'Ed Marshall leads Ed Marshall Productions NYC, capturing live music, portraits, and films in the Bronx and NYC with a non-intrusive, natural-light photojournalism style, alongside archiving his 1990s house music projects Dreamscape and Aplomb.',
    frequency: [
      {
        label: 'Visual Architecture',
        value:
          'Non-intrusive, "fly on the wall" photojournalism favoring natural and existing light to capture true-to-life portraits, events, and live music scenes.',
      },
      {
        label: 'Electronic Music History',
        value:
          'Embedded in the 1990s NYC electronic music scene as Dreamscape and Aplomb, founding New Age House Records, with reissues on World Building.',
      },
      {
        label: 'Sovereign Archive',
        value:
          'A platform-independent artist dossier: linking directly to the Ed Marshall Photography NYC Website and Ed Marshall Productions NYC YouTube Channel.',
      },
      {
        label: 'Physical-to-Digital Handshake',
        value:
          'QR card deployment at venues allows audiences to transition from physical exhibition frames to his multimedia portfolio and music archives.',
      },
    ],
    lineage: [
      'Multimedia producer and visual archivist of the NYC and Bronx creative layers, collaborating with indie artists like Honeychild Coleman.',
      'Electronic music pioneer releasing underground house music under the monikers Dreamscape and Aplomb in the 1990s.',
      'Independent label founder of New Age House Records, with compiled works reissued as Welcome To Our New Age House.',
    ],
    currentTransmission:
      'Ed Marshall is active at Kismat, NYC through street-level photojournalism, live music filming, and local community profiling. His resident presence showcases the integration of photography and classic underground electronic music archives.',
    currentNote: 'Live Music and Photojournalism Archiving at Kismat, NYC.',
    fieldEchoes: [
      'The Gig Passport solution preserves the depth of a visual artist’s portfolio without reducing the work to compressed social media fragments.',
      'In-house QR Cards produced through Epson ET-15000 precision link directly from physical venue frames to this visual profile.',
    ],
    archiveItems: [
      {
        id: 'ed-marshall-field-transmission-2026',
        title: 'Kismat Visual & Sonic Provenance — Ed Marshall Field Transmission',
        date: 'June 6, 2026',
        duration: 'Field Chronicle',
        visibility: 'public',
        type: 'audio',
        url: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/chronicles/2026/audio/2026-06-06_noon_transmission_artist-ed-marshall.mp3',
        accessUrl: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/chronicles/2026/audio/2026-06-06_noon_transmission_artist-ed-marshall.mp3',
      },
    ],
    upcomingNodes: [
      {
        date: 'FRIDAYS · WEEKLY',
        venue: 'Kismat Weekly Friday Live Music & Visual Capture',
        city: '603 Fort Washington Ave, Washington Heights, NYC',
        time: '8:30 PM – 11:30 PM',
        eventId: 'kismat-uptown-friday-2026',
      },
    ],
    integration: {
      title: 'Integration Strategy',
      body:
        'This profile positions Ed Marshall as the multimedia benchmark for Kismat resident artists: a high-fidelity Entity Archive built for venue QR deployment, visual portfolios, and 1990s electronic music legacy routing.',
    },
  },
  'girum': {
    id: 'girum',
    profileNumber: '005',
    name: 'Girum Seifu',
    role: 'Musician / Cultural Archivist / Yetibeb Moged Curator',
    city: 'rtm',
    status: 'Active Curator Hub - House of Rastafari',
    transmission: 'Yetibeb Moged / Rototom Signal',
    transmissionChronicleAudioUrl: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/chronicles/2026/audio/transmission_venue-parcel-5.mp3',
    fallbackAudioUrl: '/audio/transmission_venue-parcel-5.mp3',
    landingPath: '/rototom',
    landingLabel: 'Rototom Page',
    radarPath: '/passport/radar?city=rtm',
    tags: ['Reggae', 'Cultural Documentation', 'Yetibeb Moged', 'Ethiopian Lineage'],
    origin: {
      title: 'The Lineage Signal',
      subtitle: 'Spain-Ethiopia Corridor, 2026',
      body:
        'Girum Seifu bridges roots reggae and cultural archiving, curating the Yetibeb Moged Show and Rototom coverage to preserve spiritual reggae lineage and dub sessions.',
      note:
        'The signal is roots-centered: connecting Spanish and Ethiopian communities through custom Field Passports.',
    },
    summary:
      'Girum Seifu is the curatorial force behind the Yetibeb Moged Show and Rototom Sunsplash coverage, establishing physical-to-digital coordination nodes across international roots and reggae stages.',
    frequency: [
      {
        label: 'Cultural Lineage',
        value: 'Roots reggae, spiritual lineage preservation, and live dub archiving.',
      },
      {
        label: 'International Corridor',
        value: 'Custom Field Passports bridging Spanish festival venues and Ethiopian cultural networks.',
      },
    ],
    lineage: [
      'Founder and curator of the Yetibeb Moged Show, documenting roots reggae and oral histories.',
      'International collaborations across the reggae and dub community, bringing live audio archives to the ledger.',
    ],
    currentTransmission:
      'Girum Seifu is broadcasting active curation from the House of Rastafari stage at Rototom Sunsplash 2026. His work establishes custom QR-redirect infrastructure for global reggae networks.',
    currentNote: 'Cultural Archiving and Reggae Reviews at House of Rastafari.',
    fieldEchoes: [
      'The Gig Passport serves as a sovereign archive for international roots culture, avoiding commercial streaming gatekeepers.',
    ],
    integration: {
      title: 'Integration Strategy',
      body:
        'This profile connects Girum Seifu to the Rototom Sunsplash Signal Radar, enabling verified check-ins and credential validation for festival attendees.',
    },
  },
  'taylor-hollingsworth': {
    id: 'taylor-hollingsworth',
    profileNumber: '006',
    name: 'Taylor Hollingsworth',
    role: "Sovereign Broadcaster / Folk n' Roll Lineage",
    city: 'birmingham',
    status: 'Tonight at 5:00 PM / Archive Locked',
    transmission: 'Birmingham Field Signal',
    transmissionType: 'Off-Air / Deep Archive',
    transmissionChronicleAudioUrl: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/chronicles/2026/audio/2026-05-15_midnight_transmission_artist-taylor-hollingsworth.mp3',
    fallbackAudioUrl: '/audio/2026-05-15_midnight_transmission_artist-taylor-hollingsworth.mp3',
    landingPath: '/passport/cities?view=signal&city=birmingham&role=Artist',
    landingLabel: 'Birmingham Node',
    radarPath: '/passport/radar?city=birmingham',
    associatedVenueIds: ['venue-the-nick-birmingham', 'venue-dial-back-sound'],
    tags: ["Folk n' Roll", 'Electric Folk', 'Blues', 'Fingerstyle Guitar', 'Birmingham'],
    offlineMessage:
      'Taylor Hollingsworth performs tonight at 5:00 PM at Victoria NYC. The field signal remains dark until a live transmission begins.',
    origin: {
      title: 'The Birmingham Signal',
      subtitle: 'Punk-Bred Blues / Electric Folk',
      body:
        "A punk-bred bluesman with an artful indie bend. Taylor fingerpicks an electric guitar against a mic'd foot-stomp pulse, preserving the physical energy of the room.",
      note:
        'The profile remains a permanent signal coordinate between broadcasts: a direct route to field captures, archive provenance, and upcoming physical nodes.',
    },
    summary:
      "Taylor Hollingsworth carries Alabama blues, punk economy, and indie songcraft through a one-person electric folk signal built from fingers, amplifier, voice, and floorboard rhythm.",
    frequency: [
      {
        label: 'Physical Signal',
        value: "Fingerpicked electric guitar and a mic'd foot stomp box keep the room inside the recording.",
      },
      {
        label: "Folk n' Roll Lineage",
        value: 'Punk-bred blues phrasing meets an artful indie bend without sanding away the live edges.',
      },
      {
        label: 'Sovereign Archive',
        value: 'Ambient captures remain attached to the artist and their physical transmission nodes.',
      },
    ],
    lineage: [
      'Birmingham, Alabama: punk economy, blues rootwork, and independent-room performance.',
      'Water Valley, Mississippi: Dial Back Sound and Yahola Studio session provenance.',
      'Dead Fingers legacy: acoustic rehearsal documents from 2012-2014.',
    ],
    lineageEyebrow: 'Birmingham / Water Valley Lineage',
    currentTransmission:
      "Tonight's physical signal lands at Victoria NYC. Taylor Hollingsworth performs at 5:00 PM during Miwi's Music Thing; the full program runs from 4:30 PM to 7:00 PM.",
    currentNote: 'Tonight, August 23, 2026 / Victoria NYC / Taylor at 5:00 PM.',
    archiveItems: [
      {
        id: 'taylor-dial-back-yahola-sessions',
        title: 'Dial Back Sound',
        date: 'Water Valley, MS',
        duration: 'Yahola Studio Sessions - 24-bit / 48kHz WAV',
        type: 'audio',
        visibility: 'deep_archive',
      },
      {
        id: 'taylor-the-nick-ambient-capture',
        title: 'The Nick',
        date: 'Birmingham, AL',
        duration: 'Live Ambient Capture - 1:45 audio snapshot',
        type: 'audio',
        visibility: 'deep_archive',
      },
      {
        id: 'taylor-dead-fingers-legacy',
        title: 'Dead Fingers Legacy File',
        date: '2012-2014',
        duration: 'Acoustic rehearsals',
        type: 'audio',
        visibility: 'deep_archive',
      },
    ],
    upcomingNodes: [
      {
        date: 'AUG 23, 2026',
        venue: "Miwi's Music Thing at Victoria NYC",
        city: '235 Eldridge Street, New York, NY',
        time: 'Taylor at 5:00 PM / Event 4:30–7:00 PM',
        eventId: 'event-taylor-hollingsworth-victoria-nyc-2026-08-23',
        posterUrl: '/images/taylor-hollingsworth-victoria-nyc-2026-08-23.png',
        qrCodeUrl: '/images/taylor-hollingsworth-victoria-nyc-qr.svg',
        qrTargetUrl:
          'https://togeevision.com/scan/taylor-hollingsworth?city=nyc&gigId=event-taylor-hollingsworth-victoria-nyc-2026-08-23&venueId=venue-victoria-nyc&source=artist_qr&campaignId=taylor-victoria-20260823',
      },
      {
        date: 'NODE 01',
        venue: 'The Nick',
        city: 'Birmingham, AL',
        time: 'Upcoming acoustic stomp set',
      },
      {
        date: 'NODE 02',
        venue: 'Dial Back Sound Showcase',
        city: 'Water Valley, MS',
        time: "Folk n' Roll transmission",
      },
    ],
    integration: {
      title: 'Physical-to-Digital Handshake',
      heading: 'Permanent Artist Coordinate',
      body:
        'Epson ET-15000 Gig Passport cards at The Nick and Dial Back Sound route listeners directly to this persistent artist coordinate.',
    },
  },
  'anansi-byte': {
    id: 'anansi-byte',
    profileNumber: '005',
    name: 'Anansi Byte',
    role: 'The Ledger Guardian / Cryptographic Sound Archivist',
    city: 'nyc',
    status: 'Primary Signal',
    transmission: 'TogeeVision Field Transmission No. 5',
    transmissionChronicleAudioUrl: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/chronicles/2026/audio/2026-05-15_noon_transmission_artist-anansi-byte.mp3',
    fallbackAudioUrl: '/audio/2026-05-15_noon_transmission_artist-anansi-byte.mp3',
    landingPath: '/nyc',
    landingLabel: 'NYC Page',
    radarPath: '/passport/radar?city=nyc',
    associatedVenueIds: ['kismat-washington-heights', 'venue-melophobe-bk'],
    tags: ['Provenance', 'Ledger', 'Live Code', 'Cryptographic', 'Sound Archival'],
    origin: {
      title: 'The Ledger Anchor',
      subtitle: 'Eldridge Street, 2018',
      body:
        'Anansi Byte established the first cryptographic sound archive node in a basement room on Eldridge Street, recording subcultural radio waveforms onto a distributed ledger.',
      note:
        'Provenance over pedagogy. The signal is either signed or lost.',
    },
    summary:
      'The Ledger Guardian. Cryptographic sound archivist and live-code practitioner who maps raw performance telemetry into permanent ledger coordinates. Her work anchors subcultural frequencies against algorithmic flattening.',
    frequency: [
      {
        label: 'Sonic DNA',
        value: 'Algorithmic beat-slicing, modular synthesizer textures, and raw field recordings, processed through high-refraction delay vectors.',
      },
      {
        label: 'Cryptographic Root System',
        value:
          'All recordings are cryptographically signed at ingestion, creating a verifiable chain of custody from live signal to archive.',
      },
      {
        label: 'Provenance Power',
        value:
          'Maintains structural integrity of regional signals, refusing corporate curation in favor of distributed consensus.',
      },
    ],
    lineage: [
      'Distributed ledger architecture and live-code performance systems.',
      'Decentralized sound archives and cryptographic lineage verification.',
    ],
    currentTransmission:
      'Anansi Byte is the focus artist for the NYC Field Transmission No. 5. Her live-coded frequencies and cryptographic archives are integrated directly into the Gig Passport radar grid.',
    integration: {
      title: 'Integration Strategy',
      body:
        'This profile registers the ledger-guardian coordinate on the NYC Signal Radar, linking MUX audio logs and GCS images to verified presence stamps.',
    },
    community: {
      matrix: {
        enabled: true,
        guestAccess: false,
        roomAlias: '#anansi-byte:togeevision.com',
        joinUrl: 'https://matrix.to/#/#anansi-byte:togeevision.com',
        label: 'Join Anansi Byte’s Ledger Channel',
        requiresTogeeVisionLogin: true,
      },
    },
    archiveItems: [
      {
        id: 'anansi_image_01',
        title: 'Anansi Byte — Eldridge Street Cryptographic Node',
        type: 'image',
        url: '/images/anansi_byte_showcase.png',
        accessUrl: '/images/anansi_byte_showcase.png',
        date: '2026 Ledger Capture',
        duration: 'Image',
        visibility: 'public',
      },
      {
        id: 'anansi-field-transmission-005',
        title: 'TogeeVision Field Transmission No. 5 — Anansi Byte',
        type: 'audio',
        url: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/chronicles/2026/audio/2026-05-15_noon_transmission_artist-anansi-byte.mp3',
        accessUrl: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/chronicles/2026/audio/2026-05-15_noon_transmission_artist-anansi-byte.mp3',
        date: 'May 15, 2026',
        duration: 'Field Chronicle',
        visibility: 'public',
      },
    ],
    upcomingNodes: [
      {
        date: 'FRIDAYS · WEEKLY',
        venue: 'Kismat Weekly Friday Live Music & Ledger Capture',
        city: '603 Fort Washington Ave, Washington Heights, NYC',
        time: '8:30 PM – 11:30 PM',
        eventId: 'kismat-uptown-friday-2026',
      },
      {
        date: 'BROOKLYN FIELD NODE',
        venue: 'Melophobe BK — Sista Grrrl & Subcultural Archival Node',
        city: 'Brooklyn, NY',
        time: '7:30 PM',
        eventId: 'demo-event-nyc-sistagrrrl-panel-2026',
      },
    ],
  },
  'azariah': {
    id: 'azariah',
    profileNumber: '006',
    name: 'Azariah',
    fullName: 'Darius Franklin',
    email: 'smoothfreshness@gmail.com',
    ownerEmail: 'smoothfreshness@gmail.com',
    ownerEmails: ['smoothfreshness@gmail.com', 'azariah@togeevision.com'],
    ownerUids: ['azariah', 'smoothfreshness@gmail.com'],
    authorizedEmails: ['smoothfreshness@gmail.com'],
    role: 'Underground Hip-Hop Artist / Lyricist / Digital Creator',
    city: 'rochester',
    status: 'Fringe Festival Anchor / Active Signal',
    transmission: 'Rochester Fringe Field Transmission No. 1',
    transmissionChronicleAudioUrl: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/chronicles/2026/audio/2026-09-02_noon_transmission_artist-azariah.mp3',
    landingPath: '/passport/events?city=rochester',
    landingLabel: 'Rochester Page',
    radarPath: '/passport/radar?city=rochester',
    associatedVenueIds: ['venue-la-marketa', 'venue-roc-city-skatepark', 'venue-parcel-5', 'venue-eastman-stage'],
    tags: ['Boom-Bap', 'Conscious Hip-Hop', 'Young Black And Gifted', 'Smooth Freshness Development', 'Rochester Lyricist'],
    origin: {
      title: 'The Boom-Bap, Songwriting & Honest Lyricism Signal',
      subtitle: 'Rochester, NY — Two Decades of Underground Production & Authentic Voice',
      body:
        'Azariah (Darius Franklin) has spent over two decades crafting underground hip-hop with uncompromising passion, traditional lyricism, and raw honesty. Growing up in Rochester, New York, his lyrical philosophy explores what words are truly worth—translating street-level truths, perseverance, and conscious storytelling into classic boom-bap architecture. Operating under his collective moniker Smooth Freshness Development (SFD) and as one half of celebrated Rochester rap duo Young Black And Gifted with producer Kidd Called Quest (releasing acclaimed underground projects like "Prime Time"), Azariah represents the bedrock of upstate New York lyrical culture.',
      note:
        'Classic boom-bap, authentic songwriting, and conscious hip-hop purism rooted in Rochester street-level performance.',
    },
    summary:
      'Underground hip-hop artist, lyricist, and digital creator based out of Rochester, New York. Over two decades of passion, traditional lyricism, and raw honesty, tailoring his sound to classic boom-bap and conscious hip-hop purists across regional performance hubs like LA Marketa Plaza International and Roc City Skate Park, explored in depth in his "What Words Are Worth" songwriting documentary.',
    frequency: [
      {
        label: 'Sonic DNA & Lyrical Weight',
        value: 'Classic boom-bap drum breaks, soulful sample chops, conscious lyricism, and raw, honest delivery exploring what words are truly worth.',
      },
      {
        label: 'Rochester Root System & Upstate Heritage',
        value:
          'Deeply embedded in Rochester culture from the North Clinton corridor to the East End, frequently performing live at regional hubs such as LA Marketa Plaza International and Roc City Skate Park.',
      },
      {
        label: 'Young Black And Gifted Chemistry',
        value:
          'One half of Rochester rap duo Young Black And Gifted with local producer Kidd Called Quest (Prime Time); collaborative roots with producers Onaje Jordan and Kzlo.',
      },
      {
        label: 'Smooth Freshness Development (SFD)',
        value:
          'Collective brand and label moniker anchoring his digital rollouts, live performance explanations, and independent creator footprint.',
      },
      {
        label: 'Songwriting & Voice Exploration',
        value:
          'Featured in the Wordsworth-TV documentary "What Words Are Worth", unpacking the discipline of songwriting, local upbringing, and uncovering authentic artistic voice.',
      },
    ],
    crewCritique: [
      {
        speaker: 'TogeeVision',
        register: 'Fixed Point',
        line: 'Azariah is the uncompromised frequency of upstate lyricism: two decades of boom-bap bone structure proving that what words are worth cannot be measured in algorithmic impressions.',
      },
      {
        speaker: 'Lex Gupta',
        register: 'Structural Read',
        line: 'The lever is verified: artist profile, documentary showcase, multi-track audio archive, Rochester Fringe stage coordinates from Parcel 5 to LA Marketa, and direct Matrix room routing.',
      },
      {
        speaker: 'Anansi Byte',
        register: 'Provenance Read',
        line: 'The lineage is concrete: SP-1200 chops, Young Black And Gifted sessions with Kidd Called Quest, North Clinton street grit, and the refusal to let the stream machine flatten twenty years of conscious writing into background noise.',
      },
      {
        speaker: 'Kaelen Vance',
        register: 'Blueprint Read',
        line: 'The blueprint is a sovereign hip-hop node: live cipher hubs, documentary archives, encrypted crew channels, and a permanent artist home linking the Rochester Fringe directly to the community.',
      },
    ],
    closing: 'This Transmission Chronicle allows the Tune In button to broadcast Azariah as an active field signal: classic boom-bap integrity, Young Black And Gifted lineage, Rochester Fringe anchor, and sovereign lyricism built against the content machine.',
    mediaArchaeology: {
      description: 'Azariah represents over two decades of underground hip-hop production and conscious lyricism rooted in Rochester, NY. His work with Young Black And Gifted and the SFD collective anchors the Rochester Fringe Festival with classic boom-bap architecture and upstate street-level storytelling.',
      highlight: 'Upstate Hip-Hop Lineage: SP-1200 drum chops, authentic songwriting, and Rochester street-level performance.'
    },
    provenance: {
      sourceAuthority: 'platform_curated',
      sourceMaterials: [
        'Wordsworth-TV Documentary',
        'Young Black And Gifted Archives',
        'Rochester Fringe Festival Program',
        'LA Marketa Field Recordings'
      ],
      rightsStatus: 'platform_editorial_audio'
    },
    lineage: [
      'Over 20 years of active underground hip-hop production, conscious writing, and live performance.',
      'Featured on Wordsworth-TV ("Azariah on Songwriting, Growing Up in Rochester & Finding His Voice | What Words Are Worth").',
      'Young Black And Gifted duo partnership with producer Kidd Called Quest (Prime Time).',
      'Producer collaborations with Onaje Jordan, Kzlo, and the Smooth Freshness Development (SFD) collective.',
      'Live performance presence across Rochester hubs including LA Marketa Plaza International and Roc City Skate Park.',
    ],
    archiveItems: [
      {
        id: 'azariah-what-words-are-worth-interview',
        title: 'Azariah on Songwriting, Growing Up in Rochester & Finding His Voice | What Words Are Worth',
        date: 'Wordsworth-TV Documentary',
        duration: 'In-Depth Interview',
        type: 'video',
        visibility: 'public',
        url: 'https://www.youtube.com/watch?v=X6jT5wnXMGA',
        verifiedReal: true,
      },
      {
        id: 'azariah-prime-time',
        title: 'Prime Time (Young Black And Gifted feat. Kidd Called Quest)',
        date: 'Rochester Underground Master',
        duration: 'Studio Showcase',
        type: 'audio',
        visibility: 'deep_archive',
        url: '',
      },
      {
        id: 'azariah-la-marketa-live',
        title: 'Live at LA Marketa Plaza International',
        date: 'Rochester, NY',
        duration: 'Live Performance Capture',
        type: 'video',
        visibility: 'deep_archive',
        url: '',
      },
      {
        id: 'azariah-roc-city-skatepark',
        title: 'Roc City Skate Park Session (SFD)',
        date: 'Rochester, NY',
        duration: 'Field Transmission',
        type: 'video',
        visibility: 'deep_archive',
        url: '',
      },
      {
        id: 'azariah-onaje-jordan-collab',
        title: 'Onaje Jordan & Kzlo Collaborative Sessions',
        date: 'Smooth Freshness Development',
        duration: 'Archive Vault',
        type: 'audio',
        visibility: 'deep_archive',
        url: '',
      },
    ],
    upcomingNodes: [],
    currentTransmission:
      'Azariah is the focus artist for the Rochester Fringe Field Transmission No. 1. His two decades of underground boom-bap production, conscious lyricism, and Young Black And Gifted archive anchor the Rochester Gig Passport radar.',
    integration: {
      title: 'Rochester Fringe Outreach Signal',
      body:
        'This profile registers the primary underground hip-hop anchor for the Rochester signal grid, linking Young Black And Gifted archives, the Wordsworth-TV documentary, and community passport check-ins.',
    },
    socialLinks: {
      facebook: 'https://www.facebook.com/ah.franklin.981868',
      instagram: 'https://www.instagram.com/azariahsfd/',
      music: 'https://www.facebook.com/azariahmusic/',
    },
    community: {
      matrix: {
        enabled: true,
        guestAccess: false,
        roomAlias: '#azariah:togeevision.com',
        joinUrl: 'https://matrix.to/#/#azariah:togeevision.com',
        label: 'Join Azariah’s Rochester Signal Channel',
        requiresTogeeVisionLogin: true,
      },
    },
  },
  'paula-maria-persiani': {
    id: 'paula-maria-persiani',
    profileNumber: '007',
    name: 'Paula Maria Persiani',
    role: 'Visual Artist / Nuyorican & Diasporican Archivist',
    city: 'nyc',
    status: 'Field Transmission Active — NoMAA Gallery',
    transmission: "NoMAA Gallery: 'Dear Earth… Love, Uptown' & 'Aquí Me Quedo — Los Cepeda'",
    transmissionChronicleAudioUrl: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/audio/transmission_venue-nomaa-gallery-nyc.mp3',
    fallbackAudioUrl: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/audio/transmission_venue-nomaa-gallery-nyc.mp3',
    carriers: {
      en: {
        audioUrl: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/audio/transmission_venue-nomaa-gallery-nyc.mp3',
        audioReady: true,
      },
      'fr-CA': {
        audioUrl: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/audio/transmission_venue-nomaa-gallery-nyc_fr-ca.mp3',
        audioReady: true,
      },
    },
    landingPath: '/passport/transmissions/venue-nomaa-gallery-nyc',
    landingLabel: 'NoMAA Transmission',
    radarPath: '/passport/radar?city=nyc',
    associatedVenueIds: ['venue-nomaa-gallery-nyc', 'kismat-washington-heights'],
    image: '/images/transmissions/nyc/paula-maria-persiani-aqui-me-quedo-loiza.png',
    imageAlt: "Paula Maria Persiani's mixed-media painting 'Aquí Me Quedo — Los Cepeda' (Loíza, Puerto Rico) at NoMAA Gallery",
    tags: [
      'Nuyorican',
      'Diasporican',
      'Loíza, Puerto Rico',
      'Aquí Me Quedo',
      'Los Cepeda',
      'NoMAA Gallery',
      'Washington Heights',
    ],
    origin: {
      title: 'The Uptown-to-Loíza Sovereignty Signal',
      subtitle: 'Washington Heights (Mott Hall) & Loíza, Puerto Rico',
      body:
        "Raised Uptown in Manhattan and educated at Mott Hall, Paula Maria Persiani creates mixed-media visual works rooted in historical, cultural, and class consciousness across the Nuyorican / Diasporican corridor. Her work 'Aquí Me Quedo — Los Cepeda'—featured at the Northern Manhattan Arts Alliance (NoMAA) Gallery exhibition 'Dear Earth… Love, Uptown'—captures a bright yellow concrete house in Loíza, Puerto Rico surrounded by tropical foliage begun on the island and completed in New York.",
      note:
        'Art without historical and class context makes it hard for a community to connect. Aquí Me Quedo — Here I Stay.',
    },
    summary:
      "Uptown NYC and Nuyorican visual artist featured in 'Dear Earth… Love, Uptown' at the Northern Manhattan Arts Alliance (NoMAA) Gallery (4140 Broadway at 176th Street). Her mixed-media canvas 'Aquí Me Quedo — Los Cepeda' bridges Washington Heights and Loíza, Puerto Rico—honoring post-emancipation Afro-Puerto Rican memory, the Cepeda family's preservation of the African bomba drum, and land sovereignty against private equity displacement.",
    frequency: [
      {
        label: 'Loíza & Post-Emancipation Memory',
        value:
          'Documents the bright yellow concrete house in Loíza, Puerto Rico—where formerly enslaved Africans built community after emancipation—honoring Los Cepeda and the preservation of the African drum in Puerto Rican culture.',
      },
      {
        label: 'Cross-Corridor Creation (Puerto Rico to NYC)',
        value:
          'Filmed on location in Loíza, with tropical foliage begun in Puerto Rico and carried home to Uptown NYC where the final canvas was assembled.',
      },
      {
        label: 'Aquí Me Quedo — Land & Class Sovereignty',
        value:
          "Stands against private equity firms and corporate speculators buying up Puerto Rico and displacing native residents, embedding historical and class context into ecological art.",
      },
    ],
    lineage: [
      'Uptown Manhattan upbringing and Mott Hall educational roots in Washington Heights / Harlem.',
      'Afro-Puerto Rican cultural memory in Loíza and the Cepeda family (Familia Cepeda) bomba drum tradition.',
      "Featured artist in the Northern Manhattan Arts Alliance (NoMAA) exhibition 'Dear Earth… Love, Uptown' (4140 Broadway, NYC).",
    ],
    currentTransmission:
      "Paula Maria Persiani is featured in the NoMAA Gallery field transmission for 'Dear Earth… Love, Uptown' at 4140 Broadway (at 176th Street), unpacking 'Aquí Me Quedo — Los Cepeda' and the living bridge between Uptown NYC and Loíza, Puerto Rico.",
    visualAssets: [
      {
        id: 'photo-paula-maria-persiani-aqui-me-quedo',
        type: 'image',
        src: '/images/transmissions/nyc/paula-maria-persiani-aqui-me-quedo-loiza.png',
        title: "Paula Maria Persiani: 'Aquí Me Quedo — Los Cepeda' (Loíza, Puerto Rico)",
        caption:
          "Mixed-media painting by Paula Maria Persiani depicting a bright yellow concrete house in Loíza, Puerto Rico surrounded by tropical foliage crafted across Puerto Rico and NYC, honoring the Afro-Puerto Rican Cepeda family ('Los Cepeda') and declaring 'Aquí Me Quedo' ('Here I Stay').",
      },
      {
        id: 'photo-nomaa-dear-earth-love-uptown-gallery',
        type: 'image',
        src: '/images/transmissions/nyc/nomaa-dear-earth-love-uptown-gallery.jpg',
        title: "NoMAA Gallery Opening Reception: 'Dear Earth… Love, Uptown'",
        caption:
          "Uptown community gathered at the Northern Manhattan Arts Alliance (NoMAA) Gallery at 4140 Broadway (at 176th Street) beneath the exhibition title 'Dear Earth... Love, Uptown.'",
      },
    ],
    archiveItems: [
      {
        id: 'persiani-aqui-me-quedo-canvas',
        title: "Aquí Me Quedo — Los Cepeda (Loíza, Puerto Rico / Uptown NYC)",
        type: 'image',
        url: '/images/transmissions/nyc/paula-maria-persiani-aqui-me-quedo-loiza.png',
        accessUrl: '/images/transmissions/nyc/paula-maria-persiani-aqui-me-quedo-loiza.png',
        date: 'October 22, 2026 · NoMAA Gallery',
        duration: 'Mixed-Media Canvas',
        visibility: 'public',
      },
      {
        id: 'persiani-nomaa-field-transmission-008',
        title: "NoMAA Gallery Field Transmission — 'Dear Earth… Love, Uptown'",
        type: 'audio',
        url: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/audio/transmission_venue-nomaa-gallery-nyc.mp3',
        accessUrl: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/audio/transmission_venue-nomaa-gallery-nyc.mp3',
        date: 'October 22, 2026',
        duration: '03:22 Field Chronicle',
        visibility: 'public',
      },
    ],
    upcomingNodes: [
      {
        date: 'OCT 22 – DEC 2026',
        venue: "NoMAA Gallery — 'Dear Earth… Love, Uptown'",
        city: '4140 Broadway (at 176th St), Washington Heights, NYC',
        time: 'Gallery Exhibition & Field Archive',
        eventId: 'event-nomaa-dear-earth-love-uptown-2026-10-22',
        venueId: 'venue-nomaa-gallery-nyc',
      },
    ],
    integration: {
      title: 'Uptown-to-Loíza Corridor Link',
      body:
        'Connects the Northern Manhattan Arts Alliance (NoMAA) gallery at 4140 Broadway directly to the NYC Signal Radar and the Nuyorican / Diasporican cultural ledger.',
    },
  },
  // Facts below come from Field Transmission No. 009 (services/backend/trigger/transmissions/pianos-nyc.json),
  // except the former name, which was supplied by the editor.
  'the-veldt': {
    id: 'the-veldt',
    profileNumber: '008',
    name: 'The Veldt',
    formerNames: ['Apollo Heights'],
    role: 'Afro-Futurist Soul-Shoegaze Band / Founders of the I Have A Dream Pop Festival',
    city: 'nyc',
    status: 'Field Transmission Active - Pianos NYC',
    transmission: "Pianos NYC: 'I Have A Dream Pop Festival' - The Veldt ('Christine')",
    landingPath: '/nyc',
    landingLabel: 'NYC Page',
    radarPath: '/passport/radar?city=nyc',
    associatedVenueIds: ['pianos-nyc'],
    tags: ['Shoegaze', 'Dream Pop', 'Afro-Futurist Soul', 'Post-Punk', 'Lower East Side'],
    image: '/images/transmissions/nyc/pianos-the-veldt-full-band-live.jpg',
    imageAlt: 'The Veldt full five-piece lineup performing at the Pianos Showroom during the I Have A Dream Pop Festival',
    imageCaption:
      'Twin brothers Daniel and Danny Chavis and the full five-piece lineup of The Veldt locked into a wall of shoegaze and soul guitar reverb in front of a packed Pianos Showroom crowd.',
    origin: {
      title: 'The Afro-Futurist Shoegaze Blueprint',
      subtitle: 'North Carolina roots, Lower East Side stage',
      body:
        'The Veldt are identical twin brothers Daniel and Danny Chavis and the five-piece lineup around them: a pioneering Afro-futurist soul-shoegaze band with North Carolina roots. They were formerly known as Apollo Heights. They founded the I Have A Dream Pop Festival, which turns Pianos at 158 Ludlow Street into a wall of twelve-string Vox Phantom chime and cathedral reverb.',
      note:
        'The festival links North Carolina, Portland (Maine), and the Lower East Side into an anti-gatekeeper mutual-aid circuit.',
    },
    summary:
      "The Veldt, identical twin brothers Daniel and Danny Chavis and their five-piece lineup, are pioneers of Afro-futurist soul-shoegaze with North Carolina roots, formerly known as Apollo Heights. They founded the I Have A Dream Pop Festival and opened its Friday night at Pianos NYC with 'Christine'.",
    frequency: [
      {
        label: 'Sound',
        value:
          "Shoegaze and soul guitar reverb, anchored by Daniel Chavis's signature red teardrop Vox Phantom XII twelve-string.",
      },
      {
        label: 'Festival',
        value:
          'The I Have A Dream Pop Festival reclaims the Black and Afro-futurist roots of shoegaze and dream pop.',
      },
      {
        label: 'Field Provenance',
        value:
          'Field Transmission No. 009 documents Friday night at Pianos, October 23, 2026, with four live stage captures of The Veldt.',
      },
    ],
    lineage: [
      'Identical twin brothers Daniel and Danny Chavis, performing with a five-piece lineup.',
      'Pioneers of Afro-futurist soul-shoegaze with North Carolina roots.',
      'Formerly known as Apollo Heights.',
      'Founders of the I Have A Dream Pop Festival at Pianos on Ludlow Street.',
    ],
    currentTransmission:
      "The Veldt opened Friday night of the I Have A Dream Pop Festival at Pianos NYC on October 23, 2026 with 'Christine'. The night is logged as Field Transmission No. 009.",
    currentNote: 'Field Transmission at Pianos NYC, 158 Ludlow Street.',
    fieldEchoes: [
      'Before the opening track, Daniel Chavis charged the room to share the sound, refuse to be gatekeepers, take care of each other, and never give up.',
    ],
    integration: {
      title: 'Integration Strategy',
      body:
        'This profile ties The Veldt to the Pianos NYC node on the NYC Signal Radar and to Field Transmission No. 009, so the festival night and the band share one provenance record.',
    },
    media: [
      {
        id: 'veldt-pianos-friday-showroom-video-2026-10-23',
        title: "The Veldt Live at Pianos NYC Showroom — 'I Have A Dream Pop Festival' (Friday Night)",
        type: 'Friday Oct 23, 2026 · Pianos NYC Showroom (158 Ludlow St)',
        url: 'https://drive.google.com/file/d/1Kp1Aqz6k-DKRYmi917TsQRHjVGd3-kL7/view?usp=drive_link',
        thumbnailUrl: '/images/transmissions/nyc/pianos-the-veldt-full-band-live.jpg',
        signal: "Live Friday night Showroom video capture of The Veldt (Daniel & Danny Chavis and five-piece band) performing at Pianos NYC (158 Ludlow Street) during the 'I Have A Dream Pop Festival.'",
      },
      {
        id: 'veldt-apollo-heights-dakini-hi8',
        title: 'Dakini — Apollo Heights (The Veldt) Live at Ella, East Village NY',
        type: 'East Village Digital Hi-8 Capture · White Music for Black People',
        url: 'https://vimeo.com/8833617',
        signal: "Archival Digital Hi-8 live capture by Delano Franklin of Apollo Heights (Daniel & Danny Chavis) performing 'Dakini' from the album 'White Music for Black People' at Ella in the East Village, NY.",
      },
      {
        id: 'veldt-apollo-heights-after-taste-hi8',
        title: 'After Taste — Apollo Heights (The Veldt) Live at Ella, East Village NY',
        type: 'East Village Digital Hi-8 Capture · Ella Lounge',
        url: 'https://vimeo.com/8833044',
        signal: "Archival Digital Hi-8 live capture by Delano Franklin of Apollo Heights (Daniel & Danny Chavis) performing 'After Taste' at Ella in the East Village, NY.",
      },
    ],
    gallery: [
      {
        id: 'veldt-gallery-pianos-dream-pop-poster',
        url: '/images/transmissions/nyc/pianos-i-have-a-dream-pop-festival-poster-2026-10-24.png',
        title: "I Have A Dream Pop Festival (Sat. 10/24/26 NYC) Official Poster",
        alt: "I Have A Dream Pop Festival Saturday 10/24/26 NYC poster at Pianos featuring The Veldt, Burnt Sugar, and Honeychild Coleman's DEM",
        caption: "Official Saturday 10/24/26 NYC poster for the 'I Have A Dream Pop Festival' at Pianos (158 Ludlow St., L.E.S.) founded by Daniel and Danny Chavis of The Veldt.",
        date: 'October 24, 2026 · Pianos NYC',
      },
      {
        id: 'veldt-gallery-pianos-vox-phantom',
        url: '/images/transmissions/nyc/pianos-the-veldt-chavis-vox-phantom.jpg',
        title: 'Daniel Chavis & Red Vox Phantom XII at Pianos Showroom',
        alt: 'Daniel Chavis of The Veldt performing with his red teardrop Vox Phantom XII twelve-string guitar at Pianos NYC',
        caption: "Daniel Chavis of The Veldt performing under cobalt stage light at Pianos (158 Ludlow Street) with his signature red teardrop Vox Phantom XII twelve-string guitar during the 'I Have A Dream Pop Festival.'",
        date: 'October 23, 2026 · Pianos NYC',
      },
      {
        id: 'veldt-gallery-pianos-full-band',
        url: '/images/transmissions/nyc/pianos-the-veldt-full-band-live.jpg',
        title: 'The Veldt Five-Piece Wall of Sound at Pianos NYC',
        alt: 'The Veldt full five-piece lineup performing at the Pianos Showroom',
        caption: 'Twin brothers Daniel and Danny Chavis and the full five-piece lineup of The Veldt locked into a wall of shoegaze and soul guitar reverb in front of a packed Pianos Showroom crowd.',
        date: 'October 23, 2026 · Pianos NYC',
      },
    ],
    archiveItems: [
      {
        id: 'veldt-pianos-friday-showroom-video-2026-10-23',
        title: "The Veldt Live at Pianos NYC Showroom — 'I Have A Dream Pop Festival' (Friday Night Capture)",
        date: 'October 23, 2026 · Pianos NYC Showroom',
        duration: 'Live Field Video',
        visibility: 'public',
        type: 'video',
        url: 'https://drive.google.com/file/d/1Kp1Aqz6k-DKRYmi917TsQRHjVGd3-kL7/view?usp=drive_link',
        accessUrl: 'https://drive.google.com/file/d/1Kp1Aqz6k-DKRYmi917TsQRHjVGd3-kL7/view?usp=drive_link',
        thumbnail: '/images/transmissions/nyc/pianos-the-veldt-full-band-live.jpg',
        notes: "Friday night Showroom live video capture of Afro-futurist soul-shoegaze pioneers The Veldt (twin brothers Daniel & Danny Chavis and five-piece band) performing at Pianos NYC (158 Ludlow Street) during the 'I Have A Dream Pop Festival.'",
      },
      {
        id: 'veldt-apollo-heights-dakini-vimeo-8833617',
        title: 'Dakini — Apollo Heights (The Veldt) Live at Ella, East Village NY (Hi-8 Archive)',
        date: 'East Village Hi-8 Capture · Ella Lounge',
        duration: '03:55 Hi-8 Video',
        visibility: 'public',
        type: 'video',
        url: 'https://vimeo.com/8833617',
        accessUrl: 'https://vimeo.com/8833617',
        thumbnail: 'https://i.vimeocdn.com/video/42220179-36894c38ce0fe3ce06b21b54cad69ce524109cf44ec35c2e49621e2bbb486e13-d_640?region=us',
        notes: "Archival Digital Hi-8 capture by Delano Franklin of Apollo Heights (formerly known as Apollo Heights, twin brothers Daniel and Danny Chavis of The Veldt) performing 'Dakini' from 'White Music for Black People' live at Ella in the East Village, NY.",
      },
      {
        id: 'veldt-apollo-heights-after-taste-vimeo-8833044',
        title: 'After Taste — Apollo Heights (The Veldt) Live at Ella, East Village NY (Hi-8 Archive)',
        date: 'East Village Hi-8 Capture · Ella Lounge',
        duration: '05:21 Hi-8 Video',
        visibility: 'public',
        type: 'video',
        url: 'https://vimeo.com/8833044',
        accessUrl: 'https://vimeo.com/8833044',
        thumbnail: 'https://i.vimeocdn.com/video/42216601-6917dc3a4f9e596c1fa8c8a3dc7480e0b9b055290d3f90f643f4daf507332f01-d_640?region=us',
        notes: "Archival Digital Hi-8 capture by Delano Franklin of Apollo Heights (twin brothers Daniel and Danny Chavis of The Veldt) performing 'After Taste' live at Ella in the East Village, NY.",
      },
      {
        id: 'veldt-pianos-dream-pop-poster-2026-10-24',
        title: "I Have A Dream Pop Festival (Sat. 10/24/26 NYC) Official Lineup Poster — Pianos NYC",
        date: 'October 24, 2026 · Pianos NYC',
        duration: 'Festival Poster',
        visibility: 'public',
        type: 'image',
        url: '/images/transmissions/nyc/pianos-i-have-a-dream-pop-festival-poster-2026-10-24.png',
        accessUrl: '/images/transmissions/nyc/pianos-i-have-a-dream-pop-festival-poster-2026-10-24.png',
        image: '/images/transmissions/nyc/pianos-i-have-a-dream-pop-festival-poster-2026-10-24.png',
        thumbnail: '/images/transmissions/nyc/pianos-i-have-a-dream-pop-festival-poster-2026-10-24.png',
        notes: "Official Saturday 10/24/26 NYC poster for the 'I Have A Dream Pop Festival' at Pianos (158 Ludlow St., L.E.S.) featuring The Veldt, Burnt Sugar (NYC), Honeychild Coleman's DEM (NYC), Spirit Hotel, Mahogany, Faith, and more.",
      },
      {
        id: 'veldt-pianos-field-transmission-2026-10-23',
        title: "Pianos NYC Field Transmission — The Veldt ('Christine'), Diary, Day & Dream & Darksoft",
        date: 'October 23, 2026 · Pianos NYC',
        duration: '03:32 Field Chronicle',
        visibility: 'public',
        type: 'audio',
        url: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/audio/transmission_venue-pianos-nyc.mp3',
        accessUrl: 'https://storage.googleapis.com/staging.togeevision-f3725.appspot.com/audio/transmission_venue-pianos-nyc.mp3',
        notes: "Friday night Showroom broadcast chronicle from Pianos NYC (158 Ludlow St) for the 'I Have A Dream Pop Festival' founded by Daniel and Danny Chavis of The Veldt, opening their set with 'Christine'.",
      },
    ],
  },
};

export const FEATURED_ARTIST_PROFILE_ID = 'monk-washington';

export const getArtistProfileByEmail = (email) => {
  if (!email) return null;
  const cleanEmail = String(email).trim().toLowerCase();
  for (const profile of Object.values(ARTIST_PROFILES)) {
    if (
      (profile.email && profile.email.toLowerCase() === cleanEmail) ||
      (profile.ownerEmail && profile.ownerEmail.toLowerCase() === cleanEmail) ||
      (Array.isArray(profile.ownerEmails) && profile.ownerEmails.some((e) => e.toLowerCase() === cleanEmail)) ||
      (Array.isArray(profile.authorizedEmails) && profile.authorizedEmails.some((e) => e.toLowerCase() === cleanEmail))
    ) {
      return profile;
    }
  }
  return null;
};

export const getArtistProfile = (profileId) => {
  if (!profileId) return null;
  const clean = profileId.replace(/^artist-/, '');
  const normalized = clean === 'monk-americana'
    ? 'monk-washington'
    : (clean === 'honeychild' ? 'honeychild-coleman' : clean);
  return ARTIST_PROFILES[normalized] || ARTIST_PROFILES[profileId] || getArtistProfileByEmail(profileId) || null;
};

export const getArtistPassportMediaPath = (profile) => {
  if (!profile?.id) return '/passport';
  const params = new URLSearchParams();
  params.set('city', profile.city || 'nyc');
  params.set('role', 'Artist');
  params.set('artistId', profile.id);
  params.set('focus', 'room-overview');
  return `/passport?${params.toString()}#artist-room-overview`;
};
